import organization from './organization/zh'
import themeSceneExport from './themeSceneExport/zh'

export default {
    route: {
        Dashboard: 'Dashiban',
        rt_tt_DMSystem: '管理系统',
        rt_tt_MbManage: '主板管理',
        rt_tt_MbControlNew: 'PC端场控',
        rt_tt_MbInfo: '主板信息',
        rt_tt_MbRunRecord: '运行记录',
        rt_tt_ThemeEdit: '主题编辑',
        rt_tt_ThmSceneEdit: '场景编辑',
        rt_tt_ThmDevEdit: '设备编辑',
        rt_tt_ThmTaskEdit: '任务编辑',
        rt_tt_SystemSetting: '系统设置',
        rt_tt_SystemManage: '系统管理',
        rt_tt_UserManage: '用户管理',
        rt_tt_DevManage: '设备管理',
        rt_org_management: '组织管理',
        rt_org_access: '组织权限',
        rt_org_users: '组织人员',
        rt_role_permissions: '角色与权限',
        rt_device_resources: '设备资源',
        rt_my_boards: '我的主板',
        rt_org_boards: '组织设备',
        rt_platform_boards: '平台设备运维',
        rt_org_themes: '组织主题',
    },
    page: {
        p99_nav_home : '回首页',
        p99_nav_sivatech : '西瓦科技',
        p99_nav_logout : '退出登陆',

        p99_sdb_tt_bd : '主板',
        p99_sdb_tt_pgs : '配置下载进度',


        p1_dsh_mb_info : '主板信息',
        p1_dsh_thm_edit : '主题编辑',
        p1_dsh_sys_setting : '系统设置',
        p1_dsh_pc_rt_ctl_new : 'PC端场控',
        p1_dsh_pc_rt_ctl : 'PC场控',
        p1_dsh_online : '在线',
        p1_dsh_tbshop : '在线商城',
        p1_dsh_help : '知识库',

        p2_rt2024_lbl_ipt_keyword : '输入主控或主题名称',
        p2_rt2024_lbl_live_only : '仅看在线',
        p2_rt2024_show_more : '勾选后，显示主控更多信息，适合单线主题场控',
        p2_rt2024_lbl_wide : '宽幅',
        p2_rt2024_lbl_idle : '空闲',
        p2_rt2024_lbl_ready : '就绪',
        p2_rt2024_lbl_running : '运行',
        p2_rt2024_lbl_finished : '结束',
        p2_rt2024_lbl_offline : '离线',
        p2_rt2024_lbl_theme : '主题： ',
        p2_rt2024_lbl_boot_theme_no_sel : '未选择启动主题',
        p2_rt2024_lbl_theme_mgr : '主题管理',
        p2_rt2024_lbl_no_running_theme : '板子没有运行的主题',
        p2_rt2024_lbl_running_theme : '运行的主题',
        p2_rt2024_lbl_sel_theme : '请选择主题',
        p2_rt2024_lbl_boot_theme : '自启动主题',
        p2_rt2024_btn_exec_theme : '执行主题',
        p2_rt2024_btn_set_boot_theme : '设置启动主题',
        p2_rt2024_msg_please_sel : '请选择',
        p2_rt2024_msg_sel_correct_theme : '请选择正确的主题',
        p2_rt2024_msg_setting : '设置中',
        p2_rt2024_msg_boot_theme_ok : '启动主题设置成功',
        p2_rt2024_msg_boot_theme_confirm_fail : '主控板未确认启动主题设置，请稍后重试',
        p2_rt2024_msg_theme_switching : '主题切换成功，正在加载主题内容...',
        p2_rt2024_msg_scene_sync_retry : '场景数据同步失败，正在重试...',
        p2_rt2024_msg_scene_sync_fail : '场景数据同步失败，请检查网络后重新进入主题',
        p2_rt2024_lbl_api_latency : '接口延时',
        p2_rt2024_lbl_api_latency_fail : '失败',
        p2_rt2024_lbl_api_latency_scene_info : '当前主题信息',
        p2_rt2024_lbl_api_latency_theme_list : '主题列表',
        p2_rt2024_lbl_api_latency_board_info : '主控信息',
        p2_rt2024_lbl_api_latency_res_config : '资源配置',
        p2_rt2024_lbl_api_latency_int_param : '运行参数',
        p2_rt2024_lbl_api_latency_subdev_info : '设备信息',
        p2_rt2024_lbl_dev_type : '设备类型',
        p2_rt2024_lbl_board_type_main : '云主控',
        p2_rt2024_lbl_board_type_plus : '云主控Plus',
        p2_rt2024_lbl_board_type_nio : '网络端口控制器',
        p2_rt2024_lbl_board_type_na : '网络音效控制器',
        p2_rt2024_lbl_dev_offline : '离线',
        p2_rt2024_lbl_dev_online : '在线',
        p2_rt2024_lbl_net_dev : '网络设备',
        p2_rt2024_lbl_lang_default : '默认',
        p2_rt2024_lbl_lang_chi : '中文(chi)',
        p2_rt2024_lbl_lang_eng : '英文(eng)',
        p2_rt2024_lbl_lang_jpn : '日语(jpn)',
        p2_rt2024_lbl_lang_kor : '韩语(kor)',
        p2_rt2024_lbl_run_limit_prefix : '可运行至: ',
        p2_rt2024_lbl_loading : '数据加载中',
        p2_rt2024_msg_task_skip_ok : '任务跳关成功',
        p2_rt2024_msg_task_skip_fail : '任务跳关失败',
        p2_rt2024_msg_skip_ok : '跳关成功',
        p2_rt2024_msg_scene_jump_ok : '场景跳转成功',
        p2_rt2024_msg_scene_jump_fail : '场景跳转失败',
        p2_rt2024_msg_scene_trig_ok : '场景效果触发成功',
        p2_rt2024_msg_scene_trig_fail : '场景效果触发失败',
        p2_rt2024_msg_task_op_ok : '任务控制成功',
        p2_rt2024_msg_task_op_fail : '任务控制失败',
        p2_rt2024_msg_operate_ok : '操作成功',
        p2_rt2024_msg_operate_fail : '操作失败',
        p2_rt2024_msg_reboot_ok : '设备重启成功',

        p2_rt2024_btn_ok : '好的',
        p2_rt2024_btn_cancel : '取消',
        p2_rt2024_cfm_reboot : '确定重启？',
        p2_rt2024_btn_reboot : '重启',
        p2_rt2024_lbl_show_act_t : '只看活跃任务',
        p2_rt2024_lbl_refresh : '刷新',
        p2_rt2024_lbl_theme_flow : '主题流程',
        p2_rt2024_lbl_ipt_dev_name : '输入设备名称',
        p2_rt2024_lbl_show_finished : '显示已完成',
        p2_rt2024_cfm_skip : '确定跳关？',
        p2_rt2024_btn_skip : '跳关',
        p2_rt2024_dev_operate : '机关操作',
        p2_rt2024_lbl_number : '序号',
        p2_rt2024_lbl_port : '端口',
        p2_rt2024_lbl_none : '无',
        p2_rt2024_lbl_name : '名称',
        p2_rt2024_lbl_status : '状态',
        p2_rt2024_lbl_operate : '操作',
        p2_rt2024_lbl_fuzzy_query : '支持关键字模糊查询',
        p2_rt2024_lbl_effect_trig : '效果触发',
        p2_rt2024_lbl_trigger : '触发',
        p2_rt2024_lbl_process_test : '流程调测',
        p2_rt2024_lbl_port_info : '端口信息',
        p2_rt2024_lbl_board_setting : '主板设置',
        p2_rt2024_lbl_loading : '玩命加载中',

        p2_2_rt_c_bpV5_ip : '输入端口',
        p2_2_rt_c_bpV5_ipb : '输入端口板',
        p2_2_rt_c_bpV5_op : '输出端口',
        p2_2_rt_c_bpV5_opb : '输出端口板',

        p2_3_rt_c_bs_cfgdata : '配置数据',
        p2_3_rt_c_bs_pctn : '已购任务数量',
        p2_3_rt_c_bs_actn : '并发任务数量',
        p2_3_rt_c_bs_pr_cnt : '已购场次',
        p2_3_rt_c_bs_ur_cnt : '已运行场次',
        p2_3_rt_c_bs_hw_ver : '硬件版本',
        p2_3_rt_c_bs_sw_ver : '固件版本',
        p2_3_rt_c_bs_btn_okay : '好的',
        p2_3_rt_c_bs_btn_cancel : '取消',
        p2_3_rt_c_bs_confirm_upd : '确定升级？',
        p2_3_rt_c_bs_do_upd : '升级',
        p2_3_rt_c_bs_more : '高级',
        p2_3_rt_c_bs_cfg_addr : '配置地址',
        p2_3_rt_c_bs_pls_input : '请输入内容',
        p2_3_rt_c_bs_addr_modify : '修改地址',
        p2_3_rt_c_bs_thm_update : '主题升级',
        p2_3_rt_c_bs_fw_addr : '固件地址',
        p2_3_rt_c_bs_fw_addr_pls_input : '请输入固件地址',
        p2_3_rt_c_bs_fw_addr_invalid : '固件地址最多115个字符，且只能包含单字节字符',
        p2_3_rt_c_bs_fw_update : '固件升级',
        p2_3_rt_c_bs_resource : '资源',
        p2_3_rt_c_bs_vid_mode : '视频模式',
        p2_3_rt_c_bs_v_cont_ud_str : '文件在于机顶盒U盘上',
        p2_3_rt_c_bs_local : '本地',
        p2_3_rt_c_bs_v_cont_inet_str : '文件在于互联网服务器上，需要公网连接，速度较慢',
        p2_3_rt_c_bs_v_cont_lan_str : '文件在于门店服务器上，速度快',
        p2_3_rt_c_bs_svr_lan_url : '服务器(局域网IP)',
        p2_3_rt_c_bs_aud_mode : '音频模式',
        p2_3_rt_c_bs_a_cont_ud_str : '文件在主控板TF卡或U盘上',
        p2_3_rt_c_bs_btn_save : '保存',
        p2_3_rt_c_bs_svr_url : '服务器网址',
        p2_3_rt_c_bs_pls_input_svr_url : '请输入服务器地址',
        p2_3_rt_c_bs_svr_lan_ip : '服务器IP地址',
        p2_3_rt_c_bs_ipt_svr_ip : '请输入IP地址',
        p2_3_rt_c_bs_svr_port : '服务器端口',
        p2_3_rt_c_bs_aud_stb_id : '音效机顶盒ID',
        p2_3_rt_c_bs_param_cfg : '参数设置',
        p2_3_rt_c_bs_detail_rtinfo : '详细运行信息',
        p2_3_rt_c_bs_run_mode : '运行模式',
        p2_3_rt_c_bs_port_mode : '端口调度模式',
        p2_3_rt_c_bs_net_dev_man : '网络设备管理',
        p2_3_rt_c_bs_net_reconn : '网络重连',
        p2_3_rt_c_bs_nio_feature : '网络端口特性',
        p2_3_rt_c_bs_btn_update : '修改',
        p2_3_rt_c_bs_lbl_unlimit : '无限制',
        p2_3_rt_c_bs_lbl_unknown : '未统计',
        p2_3_rt_c_bs_lbl_bootcnt : '启动计数',
        p2_3_rt_c_bs_lbl_lang : '语言',
        p2_3_rt_c_bs_lbl_res_code : '资源代码',
        p2_3_rt_c_bs_lbl_dev_id : '设备ID',
        p2_3_rt_c_bs_lbl_play_mode : '播放模式',
        p2_3_rt_c_bs_lbl_sel_play_mode : '请选择播放模式',
        p2_3_rt_c_bs_lbl_def_vol : '默认音量',
        p2_3_rt_c_bs_lbl_ext_amp : '外部功放',
        p2_3_rt_c_bs_lbl_switch_on : '开启',
        p2_3_rt_c_bs_lbl_switch_off : '关闭',
        p2_3_rt_c_bs_lbl_audio_ctrl : '音频控制',
        p2_3_rt_c_bs_lbl_port_limit : '端口上限设置',
        p2_3_rt_c_bs_lbl_limit : '限制',
        p2_3_rt_c_bs_lbl_no_limit : '不限制',
        p2_3_rt_c_bs_lbl_sel_date : '选择日期时间',
        p2_3_rt_c_bs_lbl_single_stop : '单曲停止',
        p2_3_rt_c_bs_lbl_single_loop : '单曲循环',
        p2_3_rt_c_bs_label_debug : '调试信息等级',
        p2_3_rt_c_bs_cloud_server : '云服务器',
        p2_3_rt_c_bs_admin_param : '管理员参数',
        p2_3_rt_c_bs_run_limit : '运行时限',
        p2_3_rt_c_bs_msg_fw_done : '升级完成',
        p2_3_rt_c_bs_msg_fw_start : '开始升级',
        p2_3_rt_c_bs_msg_fw_fail : '升级失败',
        p2_3_rt_c_bs_msg_thm_done : '主题升级完成',
        p2_3_rt_c_bs_msg_thm_timeout : '主题升级超时',
        p2_3_rt_c_bs_msg_thm_start : '开始主题更新',
        p2_3_rt_c_bs_msg_cfg_ok : '配置更新成功',
        p2_3_rt_c_bs_msg_cfg1_ok : '配置1更新成功',
        p2_3_rt_c_bs_msg_cfg2_ok : '配置2更新成功',
        p2_5_rt_c_bw_lbl_cloud_days : '可云控天数',
        p2_5_rt_c_bw_lbl_contact_svc : '如已到期，请联系客服',
        p2_5_rt_c_bw_lbl_infinite : '无限期',
        p2_5_rt_c_bw_lbl_expired : '过期',
        p2_5_rt_c_bw_lbl_days : '天',
        p2_5_rt_c_bw_msg_skip_ok : '跳关成功',
        p2_6_rt_c_tsk_c_lbl_scene_skip_title : '请选择跳转的场景',
        p2_6_rt_c_tsk_c_btn_close : '关闭',
        p2_6_rt_c_tsk_c_btn_confirm : '确认',
        p2_6_rt_c_tsk_c_lbl_assign : '赋值',
        p2_6_rt_c_tsk_c_lbl_become : '变成',
        bit_edit_lbl_current_val : '当前值',
        bit_edit_lbl_input_hint : '输入整数（支持 0x 十六进制）',
        bit_edit_lbl_decimal_val : '当前数值（十进制）',
        bit_edit_lbl_hex_val : '当前数值（十六进制）',
        bit_edit_lbl_readonly : '只读',
        bit_edit_lbl_bit : '位',
        bit_edit_lbl_bits : '位段',
        bit_edit_lbl_hex : '十六进制',
        bit_edit_lbl_dec : '十进制',
        extra_param_desc_debug_level : '调试信息等级（0-F、1-E、2-E、3-I、4-V）',
        extra_param_desc_serial_print : '打开串口打印',
        extra_param_desc_action_log_suppression : '过程中屏蔽动作日志',
        extra_param_desc_disable_network_log : '禁止网络日志',
        extra_param_desc_task_end_mode : 'Task 结束模式',
        extra_param_desc_skip_mode : '跳关模式',
        extra_param_desc_stop_same_port_output : '停止同端口的输出设备',
        extra_param_desc_ms_unit : '毫秒单位',
        extra_param_desc_multi_card_ic_timing : '多卡 IC（0）2 毫秒/（1）4 毫秒',
        extra_param_desc_remote_control_timing : '遥控器（0）8 毫秒/（1）4 毫秒',
        extra_param_desc_multi_card_gap : '多卡使用 GAP',
        extra_param_desc_nio_input_change_log : '记录 NIO 输入端口变化',
        extra_param_desc_input_port_ll : '输入端口 LL',
        extra_param_desc_output_port_ll : '输出端口 LL',
        extra_param_desc_volume_control : '音量控制',
        extra_param_desc_timer_volume_control : '通过定时器下发音量控制',
        extra_param_desc_reconnect_count : '断线重连次数',
        extra_param_desc_network_discovery_timeout : '网络设备发现超时机制',
        extra_param_desc_sockcomm_no_check : 'sockcomm 回复不校验',
        extra_param_desc_udp_token_check : '校验网络端口板 UDP Token',
        extra_param_desc_udp_sequence_check : '校验网络端口板 UDP 序列号',
        extra_param_desc_http_download_optimization : 'HTTP 下载优化',
        extra_param_desc_networkctrl_tcp_async_send : 'networkctrl TCP 异步发送',
        extra_param_desc_mobile_network_optimization : '移动网络优化',
        extra_param_desc_networkctrl_tcp_async_drop : '支持 networkctrl TCP 异步 DROP',
        extra_param_desc_input_port_status_log : '记录 Input 包中端口状态变化',
        extra_param_desc_retransmission : '重传机制',
        extra_param_desc_extradata_crc_check : 'ExtraData CRC 校验机制',
        extra_param_desc_input_module_limit : '输入模块上限（0 不限制）',
        extra_param_desc_output_module_limit : '输出模块上限（0 不限制）',
        extra_param_desc_cloud_server : '云服务器连接选择（0~2）',


        p2_4_rt_c_b5_rbt_board : '重启主控板',
        p2_4_rt_c_b5_btn_ok : '好的',
        p2_4_rt_c_b5_btn_cancel : '取消',
        p2_4_rt_c_b5_cfm_reboot : '确定重启？',
        p2_4_rt_c_b5_lbl_idle : '空闲',
        p2_4_rt_c_b5_lbl_ready : '就绪',
        p2_4_rt_c_b5_lbl_running : '运行',
        p2_4_rt_c_b5_lbl_finished : '结束',
        p2_4_rt_c_b5_lbl_offline : '离线',
        p2_4_rt_c_b5_lbl_time : '用时',
        p2_4_rt_c_b5_lbl_detail : '详情',
        p2_4_rt_c_b5_lbl_inf : '无限期',
        p2_4_rt_c_b5_lbl_outdated : '过期',
        p2_4_rt_c_b5_lbl_day : '天',
        p2_4_rt_c_b5_msg_v_days : '可云控天数: ',
        p2_4_rt_c_b5_msg_contact : '如已到期，请联系客服',

        p2_5_rt_c_bw_btn_ok : '好的',
        p2_5_rt_c_bw_btn_cancel : '取消',
        p2_5_rt_c_bw_cfm_reboot : '确定重启？',
        p2_5_rt_c_bw_cfm_skip : '确定对主任务跳关？',
        p2_5_rt_c_bw_lbl_time : '用时',
        p2_5_rt_c_bw_scene_skip : '跳关',
        p2_5_rt_c_bw_lbl_detail : '详情',

        p2_6_rt_c_tsk_c_lbl_task : '任务',
        p2_6_rt_c_tsk_c_lbl_show_finish : '显示已完成',
        p2_6_rt_c_tsk_c_btn_ok : '好的',
        p2_6_rt_c_tsk_c_btn_cancel : '取消',
        p2_6_rt_c_tsk_c_cfm_skip : '确定跳关？',
        p2_6_rt_c_tsk_c_btn_skip : '跳下一关',
        p2_6_rt_c_tsk_c_msg_skip_ok : '任务跳关成功',
        p2_6_rt_c_tsk_c_msg_skip_fail : '任务跳关失败',
        p2_6_rt_c_tsk_c_msg_op_success : '任务控制成功',
        p2_6_rt_c_tsk_c_msg_op_fail : '任务控制失败',
        p2_6_rt_c_tsk_c_msg_scene_lst : '选择场景',
        p2_6_rt_c_tsk_c_msg_scene_skip_cfm : '确认跳转到场景',

        p3_te_ztbj_theme_name : '主题名称',
        p3_te_ztbj_fuzzy_query : '支持关键字模糊查询',
        p3_te_ztbj_query : '查询',
        p3_te_ztbj_new : '新建',
        p3_te_ztbj_ide_config : 'IDE 配置',
        p3_te_ztbj_show_number : '显示序号',
        p3_te_ztbj_shs_ipt_list : '勾选显示动作条内部序号',
        p3_te_ztbj_auto_name : '自动名称',
        p3_te_ztbj_show_auto_name : '勾选后，动作名称自动添加端口号',
        p3_te_ztbj_lbl_done : '完 成',
        p3_te_ztbj_lbl_edit : '编辑',
        p3_te_ztbj_lbl_name : '名称',
        p3_te_ztbj_lbl_description : '描述',
        p3_te_ztbj_resrouce_code : '资源代码',
        p3_te_ztbj_btn_cancel : '取消',
        p3_te_ztbj_confirm : '确定',
        p3_te_ztbj_btn_share : '分享',
        p3_te_ztbj_pls_ipt_phone : '请输入手机号',
        p3_te_ztbj_find : '查找',
        p3_te_ztbj_btn_backup : '备份',
        p3_te_ztbj_btn_del : '删除',
        p3_te_ztbj_btn_cooperate : '协作',
        p3_te_ztbj_choose_date : '选择日期',
        p3_te_ztbj_own_theme : '自有主题',
        p3_te_ztbj_coop_theme : '协作主题',
        p3_te_ztbj_invalid_phone_num : '手机号不正确',
        p3_te_ztbj_usr_n_found : '未找到用户',
        p3_te_ztbj_inv_param : '参数不完整或不正确',
        p3_te_ztbj_msg_share_success : '分享成功',
        p3_te_ztbj_msg_share_failed : '分享失败',
        p3_te_ztbj_coop_success : '协作成功',
        p3_te_ztbj_coop_fail : '协作失败',
        p3_te_ztbj_bk_theme_prompt : '备份当前主题？',
        p3_te_ztbj_prompt : '提示',
        p3_te_ztbj_bk_success : '备份成功，请更新主题备注信息',
        p3_te_ztbj_bk_failed : '备份失败',
        p3_te_ztbj_cfm_del : '确认删除选中主题吗？',
        p3_te_ztbj_del_success : '删除主题成功',
        p3_te_ztbj_dev_fail : '删除主题失败',
        p3_te_ztbj_create_success : '新增主题成功',
        p3_te_ztbj_mdf_t_info_success : '修改主题基本信息成功',
        p3_te_ztbj_mdf_t_info_fail : '修改主题基本信息失败',
        p3_te_ztbj_dev_prop_empty : '有设备的属性为空,请选填',
        p3_te_ztbj_upd_confirm : '升级主题配置到最新，以获得更多玩法和功能？建议先进行一次备份',
        p3_te_ztbj_chkbar_actbar_empty : '有checkBar或actionBar为空,请先选填',
        p3_te_ztbj_thm_upd_success : '升级配置成功',
        p3_te_ztbj_read_only : '只读',
        p3_te_ztbj_lbl_owner : '所有者',
        p3_te_ztbj_lbl_mod_time : '修改时间',
        p3_te_ztbj_lbl_modify : '修改',
        p3_te_ztbj_lbl_dev_edit : '设备编辑',
        p3_te_ztbj_lbl_thm_edit : '场景编辑',
        p3_te_ztbj_lbl_task_edit : '任务编辑',
        p3_te_ztbj_lbl_upd_cfg : '升级配置',
        p3_te_ztbj_lbl_mgn : '管理',
        p3_te_ztbj_lbl_ver : '版本',
        p3_te_ztbj_share : '主题分享',
        p3_te_ztbj_coop : '主题协作',
        p3_te_ztbj_valid_day : '有效期限(天)',
        p3_te_ztbj_cooper : '协作人',
        p3_te_ztbj_op : '操作',
        p3_te_ztbj_cooperate : '协作',



        p4_lgn_tt_siva_cloud : '西瓦科技实景娱乐管理系统',
        p4_lgn_tt_pwd_lgn : '密码登录',
        p4_lgn_tt_username : '用户名',
        p4_lgn_tt_passowrd : '密码',
        p4_lgn_tt_login : '登陆',
        p4_lgn_tt_sms_lgn : '短信登录',
        p4_lgn_tt_phone : '手机号',
        p4_lgn_cap_pwd_lgn : '验证码',
        p4_lgn_tt_sec_to : '秒后获取验证码',
        p4_lgn_tt_veri_code : '获取验证码',

        p4_um_title : '用户管理',
        p4_um_btn_add_user : '新增用户',
        p4_um_filter_username : '请输入用户名',
        p4_um_loading : '加载中',
        p4_um_col_no : '序号',
        p4_um_empty_login : '还没有登录',
        p4_um_col_login_time : '登录时间',
        p4_um_col_login_ip : '登录IP',
        p4_um_col_client_info : '客户端信息',
        p4_um_col_operation : '操作',
        p4_um_btn_logout_session : '注销',
        p4_um_col_login_name : '登录名',
        p4_um_col_phone : '手机',
        p4_um_col_nickname : '昵称',
        p4_um_col_role : '角色',
        p4_um_col_owner : '所属管理员',
        p4_um_col_status : '状态',
        p4_um_status_normal : '正常',
        p4_um_status_disabled : '停用',
        p4_um_col_remark : '备注',
        p4_um_btn_edit : '编辑',
        p4_um_btn_reset_pwd : '重置密码',
        p4_um_btn_delete : '删除',
        p4_um_dialog_user_info : '用户信息',
        p4_um_dialog_user_edit : '用户编辑',
        p4_um_label_account_role : '账号角色',
        p4_um_placeholder_role : '请选择账号角色',
        p4_um_label_owner : '所属管理员',
        p4_um_placeholder_owner : '请选择所属管理员',
        p4_um_label_login_name : '登录名称',
        p4_um_label_nickname : '昵称',
        p4_um_label_password : '登录密码',
        p4_um_label_confirm_password : '重复密码',
        p4_um_label_phone : '手机号码',
        p4_um_placeholder_country_code : '区号',
        p4_um_phone_placeholder : '请输入手机号码',
        p4_um_placeholder_keep_pwd : '留空表示不修改密码',
        p4_um_label_remark : '备注信息',
        p4_um_placeholder_remark : '请输入备注信息',
        p4_um_btn_cancel : '取消',
        p4_um_btn_confirm : '确定',
        p4_um_dialog_delete_title : '确认删除',
        p4_um_dialog_delete_msg : '确认删除该用户？删除后账号将无法登录。',
        p4_um_role_sivaadmin : '系统管理员',
        p4_um_role_subadmin : '分管理员',
        p4_um_role_koradmin : '韩国管理员',
        p4_um_role_staff : '内部员工',
        p4_um_role_user : '普通用户',
        p4_um_msg_delete_success : '删除用户成功',
        p4_um_msg_delete_failed : '删除用户失败',
        p4_um_msg_login_name_empty : '登录名为空',
        p4_um_msg_select_owner : '请选择所属管理员',
        p4_um_msg_phone_empty : '手机号为空',
        p4_um_msg_pwd_not_match : '两次输入不一致',
        p4_um_msg_pwd_too_short : '密码长度不足6位',
        p4_um_msg_update_success : '修改用户成功',
        p4_um_msg_update_failed : '修改用户失败',
        p4_um_msg_add_success : '新增用户成功',
        p4_um_msg_add_failed : '新增用户失败',
        p4_um_msg_session_logout_success : '用户登录注销成功',
        p4_um_msg_session_logout_failed : '用户登录注销失败',

        p5_te_dev_lbl_thm_name : '主题名称',
        p5_te_dev_lbl_add : '增加',
        p5_te_dev_lbl_finish : '完 成',
        p5_te_dev_tt_iogrp_edit : '端口组编辑',
        p5_te_dev_lbl_name : '名称',
        p5_te_dev_lbl_work_mode : '工作模式',
        p5_te_dev_lbl_pls_choose : '请选择',
        p5_te_dev_lbl_edit : '编辑',
        p5_te_dev_tt_ipt_edit : '输入端口编辑',
        p5_te_dev_lbl_sec : '秒',
        p5_te_dev_tt_opt_edit : '输出端口编辑',
        p5_te_dev_lbl_ms : '毫秒',
        p5_te_dev_lbl_down_2_brd : '下发配置',
        p5_te_dev_btn_save : '保存',
        p5_te_dev_btn_push : '下发',
        p5_te_dev_lbl_cfm_push_theme : '确定下发主题',
        p5_te_dev_lbl_2_board : '到主板',
        p5_te_dev_btn_cancel : '取 消',
        p5_te_dev_btn_confirm : '确 定',
        p5_te_dev_lbl_thm_id : '主题ID',
        p5_te_dev_lbl_res_code : '资源代码',
        p5_te_dev_lbl_svr_mode : '(用于服务器方式播放音视频)',
        p5_te_dev_lbl_note : '备注',
        p5_te_dev_btn_theme_list : '基本信息',
        p5_te_dev_btn_scene_edit : '场景编辑',
        p5_te_dev_tt_dev_order_set : '设备顺序设置',
        p5_te_dev_btn_new_dev : '新增设备',
        p5_te_dev_btn_help : '帮助',
        p5_te_dev_btn_order : '排序',
        p5_te_dev_btn_export : '设备导出',
        p5_te_dev_lbl_loading : '加载中',
        p5_te_dev_lbl_number : '序号',
        p5_te_dev_lbl_name : '名称',
        p5_te_dev_lbl_dev_edit : '设备编辑',
        p5_te_dev_tt_base_info : '基础信息',
        p5_te_dev_lbl_note : '说明',
        p5_te_dev_tt_cfg_info : '配置信息',
        p5_te_dev_tt_dev_export : '设备信息导出',
        p5_te_dev_lbl_category : '类型',
        p5_te_dev_lbl_netdev : '网络设备',
        p5_te_dev_lbl_port_no : '端口',
        p5_te_dev_lbl_input_port_output : '输入端口输出',
        p5_te_dev_hint_input_port_output : '勾选后输出端口按输入端口顺序自动生成，端口号为输入端口号加 1024',
        p5_te_dev_lbl_open_port : '开端口',
        p5_te_dev_lbl_close_port : '关端口',
        p5_te_dev_lbl_file_no : '文件序号',
        p5_te_dev_tt_cfm_push : '确认下发',
        p5_te_dev_lbl_pls_enter : '请输入',
        p5_te_dev_lbl_ro : '只读',
        p5_te_dev_btn_do_export : '导 出',
        p5_te_dev_lbl_pls_sel_bd : '请选择主板',
        p5_te_dev_msg_ro_no_saving : '只读模式，不保存跳转',
        p5_te_dev_msg_empty_condition_err : '当前场景有空的条件栏或动作栏，请选填或删除',
        p5_te_dev_msg_auto_save_ok : '自动保存成功',
        p5_te_dev_msg_auto_save_fail : '自动保存失败',
        p5_te_dev_msg_brd_lst_refresh : '主板列表已刷新',
        p5_te_dev_msg_fail_obt_blist : '获取主板列表失败',
        p5_te_dev_msg_cp_success : '复制成功',
        p5_te_dev_msg_cp_scn_first : '请先复制场景',
        p5_te_dev_msg_paste_ok : '粘贴成功',
        p5_te_dev_msg_empty_list : '列表为空',
        p5_te_dev_msg_cfg_del_scn : '确认删除该场景吗?',
        p5_te_dev_lbl_pinyin_search : '支持拼音查询',
        p5_te_dev_lbl_total : '共',
        p5_te_dev_lbl_devices : '个设备',
        p5_te_dev_msg_port_limit : '增加：数量已达上限',
        p5_te_dev_msg_dup_netdev_id : '网络设备ID有重复',
        p5_te_dev_msg_issue_auth_expired : '下发失败: 云平台权限已过期',
        p5_te_dev_msg_issue_started : '开始下载配置',
        p5_te_dev_msg_issue_fail : '下发失败:',
        p5_te_dev_cfm_del_sel_dev : '确认删除选中设备吗？',
        p5_te_dev_msg_del_dev_success : '删除设备成功',
        p5_te_dev_msg_del_dev_used : '场景编辑中使用到该设备,无法删除',
        p5_te_dev_msg_del_dev_fail : '删除设备失败',
        p5_te_dev_lbl_device_manager : '设备管理',
        p5_te_dev_lbl_device_summary : '配置摘要',


        p6_te_scn_lbl_dev_edit : '设备编辑',
        p6_te_scn_lbl_new_scn : '增加场景',
        p6_te_scn_lbl_dev_name : '设备名称',
        p6_te_scn_lbl_entr_kw : '请选择名称',
        p6_te_scn_btn_search : '查找',
        p6_te_scn_btn_export : '导出',
        p6_te_scn_btn_export_xmind : '导出思维导图',
        p6_te_scn_lbl_next_scn : '后续场景',
        p6_te_scn_lbl_delay_check : '延时判定(秒)',
        p6_te_scn_lbl_tae : '超时音效',
        p6_te_scn_lbl_timeout_sec : '超时跳关(秒)',
        p6_te_scn_lbl_pass_chk_condition : '过关判定条件',
        p6_te_scn_lbl_pass_condition : '过关条件',
        p6_te_scn_lbl_entr_kw2 : '请输入名称',
        p6_te_scn_lbl_del_condition : '删除此条件',
        p6_te_scn_lbl_add_check_grp : '增加条件组',
        p6_te_scn_lbl_add_check_unt : '增加过关判定条件',
        p6_te_scn_lbl_inprogress_action : '过程中动作',
        p6_te_scn_lbl_inprogress_eff : '过程中效果',
        p6_te_scn_lbl_del_effects : '删除此效果',
        p6_te_scn_lbl_copy_effects : '复制此效果',
        p6_te_scn_lbl_condition : '条件',
        p6_te_scn_lbl_success : '成功',
        p6_te_scn_lbl_fail : '失败',
        p6_te_scn_lbl_add_inpgs_ca : '增加过程中条件动作',
        p6_te_scn_lbl_paste_inpgs_ca : '粘贴已复制动作(有条件)',
        p6_te_scn_lbl_onfinish_actions : '过关动作',
        p6_te_scn_lbl_add_of_a_uc : '增加过关动作(无条件)',
        p6_te_scn_lbl_paste_of_a_uc : '粘贴已复制动作(无条件)',
        p6_te_scn_lbl_of_a_cdt : '过关条件动作',
        p6_te_scn_lbl_add_of_a_cdt : '增加过关动作(有条件)',
        p6_te_scn_lbl_cp_action_cdt : '粘贴已复制动作(有条件)',
        audio_beat_theme_edit: '主题编辑',
        audio_beat_scene_edit: '场景编辑',
        audio_beat_title: '音频卡点',
        audio_beat_current_scene: '当前场景',
        audio_beat_back_to_scene_edit: '返回场景编辑',
        audio_beat_no_audio: '未选择音频',
        audio_beat_choose_audio: '选择音频',
        audio_beat_pause: '暂停',
        audio_beat_play: '播放',
        audio_beat_back_to_start: '回到起点',
        audio_beat_timeline: '时间轴',
        audio_beat_zoom_out: '缩小时间轴',
        audio_beat_zoom_in: '放大时间轴',
        audio_beat_fit_timeline: '适应',
        audio_beat_reselect_audio: '重新选择',
        audio_beat_timeline_heading: '音频与过关动作',
        audio_beat_timeline_help: '拖动空白区域平移，拖动动作条调整触发时间',
        audio_beat_undo_move: '撤销移时',
        audio_beat_redo_move: '重做移时',
        audio_beat_lock_action_drag: '锁定动作条拖动',
        audio_beat_waveform: '波形',
        audio_beat_action_bars: '过关动作条',
        audio_beat_undo_this_move: '撤销本次移动',
        audio_beat_action_bar_count: '{count} 个动作条 | {count} 个动作条',
        audio_beat_action_unit_count: '{count} 个动作单元 | {count} 个动作单元',
        audio_beat_add_action_at_time: '在当前时间增加动作条',
        audio_beat_delete_action_bar: '删除动作条',
        audio_beat_no_action_bars: '暂无动作条',
        audio_beat_action_bar_edit: '动作条编辑',
        audio_beat_name: '名称',
        audio_beat_action_bar_name: '动作条名称',
        audio_beat_condition: '条件',
        audio_beat_check_action_help: '编辑 CheckAction 的触发条件',
        audio_beat_add_condition_group: '增加条件组',
        audio_beat_edit_branch: '编辑分支',
        audio_beat_action_units: '动作单元',
        audio_beat_action_unit_help: '沿用传统动作条编辑和批量增加',
        audio_beat_select_action_bar: '请选择一个动作条',
        audio_beat_new_action_hint: '新增延时：{time}。创建后在时间轴上统一显示为动作条。',
        audio_beat_unconditional_action: '无条件动作条',
        audio_beat_conditional_action: '有条件动作条',
        audio_beat_success: '成功',
        audio_beat_failure: '失败',
        audio_beat_load_failed: '加载失败',
        audio_beat_loaded: '已加载',
        audio_beat_please_choose_audio: '请选择音频文件',
        audio_beat_saved_file_unreadable: '无法读取本机保存的音频文件，请重新选择音频。',
        audio_beat_saved_file_missing: '本机未找到音频文件“{path}”的已保存内容，请重新选择一次。',
        audio_beat_local_save_failed: '音频本次可用，但未能保存到浏览器本机；下次进入时需要重新选择。',
        audio_beat_scene_id_missing: '当前场景缺少唯一标识，音频无法保存供下次恢复。',
        audio_beat_load_error: '音频加载失败：文件不存在、格式不受支持或内容已损坏。请重新选择。',
        audio_beat_play_error: '音频播放失败，请重新选择音频文件。',
        audio_beat_default_action_name: '动作条 {number}',
        audio_beat_action_bar: '动作条',
        audio_beat_keep_one_condition_group: '至少保留一个条件组',
        audio_beat_action_limit: '过关动作条数量超出限制（{limit}个）',
        audio_beat_move_time: '时间：{from} → {to}',
        audio_beat_select_scene_first: '请先选择一个场景',
        p6_te_scn_lbl_desc_txt : '描述文字',
        p6_te_scn_txt_cpoy_of : ' - 副本',
        p6_te_scn_msg_manual_save_ok : '手动保存成功',
        p6_te_scn_msg_manual_save_fail : '手动保存失败',
        p6_te_scn_msg_last_no_del : '最后一栏，无法删除',
        p6_te_scn_lbl_and : '且',
        p6_te_scn_lbl_or : '或',
        p6_te_scn_lbl_add_au : '新增动作单元',
        p6_te_scn_lbl_mod_au : '修改动作单元',
        p6_te_scn_lbl_param : '参数',
        p6_te_scn_lbl_batch_add_au : '批量增加动作',
        p6_te_scn_lbl_cp_al : '复制动作条',
        p6_te_scn_lbl_dev_cate : '设备类别',
        p6_te_scn_lbl_action : '动作',
        p6_te_scn_msg_pls_sel_a : '请选择动作',
        p6_te_scn_lbl_pass_con2 : '过关判定：',
        p6_te_scn_lbl_of_actions2 : '完成动作：',

        p6_te_scn_lbl_add_lu : '新增逻辑单元',
        p6_te_scn_lbl_mod_lu : '修改逻辑单元',
        p6_te_scn_lbl_remove : '去除',
        p6_te_scn_lbl_add_to : '增加',
        p6_te_scn_lbl_tbs : '可用',
        p6_te_scn_lbl_seled : '已选',
        p6_te_scn_lbl_batch_add : '批量新增',
        p6_te_scn_lbl_pls_chs_or_keywd : '请选择或输入关键字',
        p6_te_scn_lbl_selected : '已选择',
        p6_te_scn_lbl_ports : '个端口',
        p6_te_scn_lbl_clear : '清空',
        p6_te_scn_lbl_port_sel : '选择端口',
        p6_te_scn_lbl_port_filter_placeholder : '输入端口号或数字进行筛选(如: 1)',
        p6_te_scn_lbl_sel_ports : '已选端口',
        p6_te_scn_lbl_clear_2 : '清除',
        p6_te_scn_lbl_clear_all : '清除所有',
        p6_te_scn_lbl_pls_sel_wm : '请选择工作模式',
        p6_te_scn_txt_del_dev : '删除设备',
        p6_te_scn_msg_edit_tag_pending : '请先将编辑中的动作tag完成',
        p6_te_scn_msg_dev_create_success : '新增设备成功',
        p6_te_scn_msg_device_not_found : '未找到设备',


        p7_te_tsk_lbl_task : '任务',
        p7_te_tsk_lbl_name : '名称：',
        p7_te_tsk_lbl_entry_scn : '入口场景：',
        p7_te_tsk_lbl_enable : '使能：',
        p7_te_tsk_lbl_pls_sel_es : '请指派入口场景',

        // ===== p8: 系统设置 xtsz =====
        p8_xtsz_title : '系统设置',
        p8_xtsz_lbl_nickname : '昵称',
        p8_xtsz_lbl_login_name : '登陆名',
        p8_xtsz_lbl_phone : '手机号码',
        p8_xtsz_lbl_board_name : '主板名称',
        p8_xtsz_lbl_show_limit : '场次限制',
        p8_xtsz_lbl_search_name : '名称搜索',
        p8_xtsz_lbl_own_board : '自有主板',
        p8_xtsz_lbl_shared_board : '分享给我的主板',
        p8_xtsz_lbl_logged_client : '已登录客户端',
        p8_xtsz_btn_edit : '编辑',
        p8_xtsz_btn_search : '查找',
        p8_xtsz_btn_share : '分享',
        p8_xtsz_btn_rename : '改名',
        p8_xtsz_btn_transfer : '转移',
        p8_xtsz_btn_delete : '删除',
        p8_xtsz_btn_cancel : '取 消',
        p8_xtsz_btn_confirm : '确 定',
        p8_xtsz_btn_logout : '注销',
        p8_xtsz_dlg_user_info : '用户信息',
        p8_xtsz_dlg_change_pwd : '修改密码',
        p8_xtsz_dlg_login_pwd : '登陆密码',
        p8_xtsz_dlg_repeat_pwd : '重复密码',
        p8_xtsz_dlg_board_transfer : '主板转移',
        p8_xtsz_dlg_set_share : '设置分享',
        p8_xtsz_dlg_delete_share : '删除分享',
        p8_xtsz_dlg_edit_board : '修改主控板',
        p8_xtsz_dlg_board_limit : '主板场次限制',
        p8_xtsz_col_user : '用户',
        p8_xtsz_col_phone : '电话',
        p8_xtsz_col_validity : '有效期',
        p8_xtsz_col_operation : '操作',
        p8_xtsz_col_name : '名称',
        p8_xtsz_col_uid : 'UID',
        p8_xtsz_col_firmware : '固件版本',
        p8_xtsz_col_status : '状态',
        p8_xtsz_col_seq : '序号',
        p8_xtsz_col_login_time : '登录时间',
        p8_xtsz_col_login_ip : '登录IP',
        p8_xtsz_col_client_info : '客户端信息',
        p8_xtsz_ph_area_code : '区号',
        p8_xtsz_ph_keyword_query : '支持关键字模糊查询',
        p8_xtsz_ph_board_name : '请输入主板名称',
        p8_xtsz_ph_show_limit_hint : '0 无限制',
        p8_xtsz_ph_phone_input : '请输入手机号',
        p8_xtsz_empty_no_share : '还没有分享给任何人',
        p8_xtsz_empty_no_login : '还没有登录',
        p8_xtsz_status_online : '在线',
        p8_xtsz_status_offline : '离线',
        p8_xtsz_warn_transfer : '主板所有权转移成功后，当前用户不可操作转回，请慎重操作',
        p8_xtsz_warn_delete_share : '确认删除对此用户的分享？',
        p8_xtsz_warn_share_limit : '该设备已分享用户数量超过10人上限，请清理之后再操作',
        p8_xtsz_msg_no_transfer_user : '未设置被转移的用户',
        p8_xtsz_msg_transfer_success : '转移主板所有权操作成功',
        p8_xtsz_msg_operation_failed : '操作失败',
        p8_xtsz_msg_board_edit_success : '修改主板成功',
        p8_xtsz_msg_limit_set_success : '场次限制设置成功',
        p8_xtsz_msg_pwd_required : '请输入新密码',
        p8_xtsz_msg_pwd_mismatch : '密码两次输入不一致',
        p8_xtsz_msg_user_update_success : '修改用户成功',
        p8_xtsz_msg_user_update_failed : '修改用户失败',
        p8_xtsz_msg_phone_format_error : '手机号格式不正确',
        p8_xtsz_msg_user_not_found : '未找到用户',
        p8_xtsz_lbl_user_prefix : '用户 ',
        p8_xtsz_msg_no_share_user : '未设置被分享用户',
        p8_xtsz_msg_share_success : '分享成功',
        p8_xtsz_msg_share_cancel_success : '取消分享成功',
        p8_xtsz_msg_share_info_updated : '分享信息已更新',
        p8_xtsz_msg_get_share_info_failed : '获取分享信息失败',
        p8_xtsz_msg_token_remove_success : '用户登录注销成功',
        p8_xtsz_msg_token_remove_failed : '用户登录注销失败',
        p8_xtsz_ph_phone_placeholder : '请输入手机号',

        dn_dt_1 : '端口组',
        dn_dt_2 : '网络设备',
        dn_dt_3 : '输入端口',
        dn_dt_4 : '输出端口',
        dn_dt_5 : '输出-门/锁',
        dn_dt_6 : '门',
        dn_dt_7 : '输出-灯',
        dn_dt_8 : '音效',
        dn_dt_9 : '超时音效',
        dn_dt_10 : '背景音',
        dn_dt_11 : '视频',
        dn_dt_12 : '图片',
        dn_dt_13 : '网络互动',
        dn_dt_14 : '计数器',
        dn_dt_30 : '任务',
        dn_dt_31 : '始终执行',
        dn_dt_32 : '跳关',
        dn_dt_33 : '网络设备就绪',
        dn_dt_34 : '房间收拾完成',
        dn_dt_35 : '主题开始',
        dn_dt_36 : '主题通关',
        dn_dt_39 : '场景效果',
        dn_dt_40 : '语言设置',
     

        dn_dt_1_p1 : '工作模式',
        dn_dt_1_p2 : '网络模块',
        dn_dt_1_p3 : '启动端口',
        dh_dt_1_p1 : '外部模块：多按键板、电话机。其他：主板上的端口',
        mn_dt_1_p1 : ['外接模块', '顺序按键', '顺序输出', '节拍输出',  '输入并联', '输入串联', '无序按键', '循环按键', '按键计数','节奏判定(敲门)','地鼠模式','记忆按键','呼吸灯组','多卡顺序识别','旋转编码器','数字输入输出'],


        dn_dt_2_p1 : '搜寻模式',
        dn_dt_2_p2 : '网络设备ID',
        dn_dt_2_p3 : 'IP地址',
        dn_dt_2_p4 : 'IP端口',
        mn_dt_2_p1 : ['自动发现', '指定IP和端口'],

        dn_dt_3_p1 : '工作模式',
        dn_dt_3_p2 : '端口号',
        dn_dt_3_p3 : '网络模块',
        dn_dt_3_p4 : '计数',
        dn_dt_3_p5 : '延时(秒)',
        // mn_dt_3_p1 : ['普通', '按键按下', '按键释放', '触发计数', '触发计数(限时)', '按下持续时间', '松开持续时间', '间断按下持续时间', '反向信号', '流程复位','多卡识别','遥控接收'],
        mn_dt_3_p1 : ['普通', //0
        '按键按下', // 1
        '按键释放', //2
        '触发计数', //3
        '触发计数(限时)',  //4
        '按下持续时间', //5
        '松开持续时间', //6
        '间断按下持续时间', //7 
        '反向信号', //8
        '流程复位', //9
        '多卡识别', //10
        '遥控接收', //11
        '遥控跳关',
        '输出端口跟随',
        '限时按下判定'],



        dn_dt_4_p1 : '工作模式',
        dn_dt_4_p2 : '端口号',
        dn_dt_4_p3 : '网络模块',
        dn_dt_4_p4 : '计数',
        dn_dt_4_p5 : '亮度(低)',
        dn_dt_4_p6 : '亮度(高)',
        dn_dt_4_p7 : '毫秒级控制',
        dn_dt_4_p8 : '开启时长',
        dn_dt_4_p9 : '关闭时长',
        dn_dt_4_p10 : '结束状态',
        mn_dt_4_p1 : ['普通', '循环', '随机循环', '预设亮度', '渐亮渐灭', '随机闪烁', '呼吸效果','保留','状态跟随'],
        mn_dt_4_p2 : ['关', '开'],

        dn_dt_5_p1 : '工作模式',
        dn_dt_5_p2 : '网络模块',
        dn_dt_5_p3 : '开门端口',
        dn_dt_5_p4 : '关门端口',
        dn_dt_5_p5 : '行程时间(秒)',
        mn_dt_5_p1 : ['未定义', '电磁锁(接常开)', '闭门器(常开)', '推杆电机', '电磁锁(接常闭)', '闭门器(常闭)', '闭门器带电磁锁'],

        dn_dt_7_p1 : '端口',
        dn_dt_7_p2 : '亮度',

        dn_dt_8_p1 : '文件编号',
        dn_dt_8_p2 : '机顶盒编号',


        dn_dt_9_p1 : '文件编号',
        dn_dt_9_p2 : '顶盒编号',
        dn_dt_9_p3 : '播放音量',

        dn_dt_10_p1 : '文件编号',
        dn_dt_10_p2 : '机顶盒编号',
        dn_dt_10_p3 : '播放音量',

        dn_dt_11_p1 : '文件编号',
        dn_dt_11_p2 : '播放协议',
        dn_dt_11_p3 : '机顶盒编号',
        dn_dt_11_p4 : '视频长度(秒)',
        dn_dt_11_p5 : '播放地址(文件名)',
        dn_dt_11_p6 : '播放音量',
        dn_dt_11_p2_p1 : ['常规(FILE/HTTP)', '实时监控'],
        dh_dt_11_p1 : '存放在机顶盒U盘上的文件名(编号部分)',
        dh_dt_11_p2 : '存放在服务器上的文件名',

        dn_dt_12_p1 : '图片文件编号',
        dn_dt_12_p2 : '机顶盒编号',
        dn_dt_12_p3 : '播放地址(文件名)',
        dh_dt_12_p1 : '存放在U盘上的文件名',

        dn_dt_13_p1 : '互动环节编号',
        dn_dt_13_p2 : '机顶盒编号',

        dn_dt_14_p1 : '工作模式',
        dn_dt_14_p2 : '网络模块',
        mn_dt_14_p1 : ['数值','计时器'],

        p98_djcfg_sel_itm_local : '本机',

        

        p97_devcfg_stn_dt_1 : ['失败','成功','','','','','','','','','','','','','','','运行'],
        p97_devcfg_stn_dt_2 : ['离线', '在线'],
        p97_devcfg_stn_dt_3 : ['无效', '有效'],
        p97_devcfg_stn_dt_4 : ['关闭', '开启'],
        p97_devcfg_stn_dt_5 : ['开启', '开启中', '关闭中', '关闭'],
        p97_devcfg_stn_dt_7 : ['关闭', '开启'],
        p97_devcfg_stn_dt_6 : ['关闭', '开启'],
        p97_devcfg_stn_dt_8 : ['正常', '正常'],
        p97_devcfg_stn_dt_10 : ['停止', '播放', '播放', '暂停'],
        p97_devcfg_stn_dt_11 : ['停止', '播放', '播放', '暂停'],
        p97_devcfg_stn_dt_12 : ['停止', '播放'],
        p97_devcfg_opn_dt_12_op_0 : '停止',
        p97_devcfg_opn_dt_12_op_1 : '播放',
        p97_devcfg_stn_dt_13 : ['停止', '运行'],
        p97_devcfg_stn_dt_14 : ['停止', '运行'],
        p97_devcfg_opn_dt_1_op_0 : '关',
        p97_devcfg_opn_dt_1_op_1 : '开',
        p97_devcfg_opn_dt_4_op_0 : '关',
        p97_devcfg_opn_dt_4_op_1 : '开',
        p97_devcfg_opn_dt_5_op_0 : '开',
        p97_devcfg_opn_dt_5_op_1 : '关',
        p97_devcfg_opn_dt_7_op_0 : '关',
        p97_devcfg_opn_dt_7_op_1 : '开',
        p97_devcfg_opn_dt_6_op_0 : '关',
        p97_devcfg_opn_dt_6_op_1 : '开',
        p97_devcfg_opn_dt_8_op_1 : '播放',
        p97_devcfg_opn_dt_10_op_1 : '播放',
        p97_devcfg_opn_dt_10_op_3 : '暂停',
        p97_devcfg_opn_dt_10_op_2 : '恢复',
        p97_devcfg_opn_dt_10_op_0 : '停止',
        p97_devcfg_opn_dt_11_op_1 : '播放',
        p97_devcfg_opn_dt_11_op_2 : '恢复',
        p97_devcfg_opn_dt_11_op_3 : '暂停',
        p97_devcfg_opn_dt_11_op_0 : '停止',
        p97_devcfg_opn_dt_13_op_1 : '启动',
        p97_devcfg_opn_dt_13_op_0 : '停止',

        dh_dt_1_p12 : '失败时，自动播放的音效编号。0 不播放',
        dh_dt_1_p13 : '成功时，自动播放的音效编号。0 不播放',
        hc_dt_1 : '<h3>外部多按键模块、电话机，或主板的多个输入、输出端口</h3><br/>  <p><li>工作模式<ul><li>外部模块：需要配置信号1(DA)端口和信号2(CK)端口<br/>    <ul>      <li>信号1(DA)端口: 结果端口</li>      <li>信号2(CK)端口: 触发端口</li>    </ul>    </li><br/>  <li>顺序按键：按顺序添加(勾选)主板端口，当这些端口按顺序触发时，端口组产生正确信号</li></br>  <li>顺序输出：输出端口列表中，按顺序添加主板输出端口，这些端口会依次亮起<br/>    <ul>      <li>启动端口: 每个端口点亮的时间(1=0.1秒)</li>      <li>停止端口: 每个端口熄灭的时间(1=0.1秒)</li>      <li>信号1(DA)端口: 端口是否熄灭控制 0 熄灭，1 不熄灭</li>      <li>信号2(CK)端口: 循环控制 0 循环，1不循环</li>    </ul>    </li></br>  <li>输入并联：输出端口列表中，添加主板输入端口；当这些端口任一个被触发时，端口组产生正确信号</li></br>  <li>输入串联：输出端口列表中，添加主板输入端口；当这些端口任一个被触发时，端口组产生正确信号</li></br>  <li>无序按键：输出端口列表中，添加主板输入端口；当这些端口均被触发过后，端口组产生正确信号</li></br>  <li>循环按键：输出端口列表中，按顺序添加主板输入端口；当这些端口按顺序触发，端口组产生正确信号。不产生错误信号</li></br>  <li>按键计数：输出端口列表中，按顺序添加主板输入端口；输出端口列表中，填入每个端口应该按下的次数</br>    当这些端口按下指定次数后，端口组产生正确信号。</li></br>  <li>呼吸灯组：输出端口列表中，添加需要参与呼吸效果的端口；</br>    <ul>      <li>呼吸速度：呼吸的速度，值越大呼吸越慢</li>      <li>停在最亮、最暗的时间</li>      <li>最大亮度：灯的最大亮度，1-100</li>    </ul></li></br>  <li>多卡顺序识别：判定依次感应的IC卡编号，符合顺序的过关</br>    <ul>      <li>呼吸速度：呼吸的速度，值越大呼吸越慢</li>      <li>停在最亮、最暗的时间</li>      <li>答案列表：依次添加需要刷的卡号</li>    </ul>  </li></br>  </li></p>',
        hc_dt_10 : '<h3>背景音</h3><br/>  <span>背景音开始播放后进入循环播放模式，支持本地模式(U盘或TF卡)<br/>和网络模式(通过音效机顶盒)</span>  <p><li>文件编号<ul><li>音效对应的文件编号，文件在U盘或服务器上以编号.mp3命名。<br/>  如001.mp3,002.mp3</li><br/>  </li></p>  ',
        hc_dt_11 : '<h3>视频</h3><br/>  <span>视频支持本地模式(播放位于机顶盒上的U盘中的视频文件)<br/>  和网络模式(播放门店服务器中的视频文件)</span>    <li>文件编号: 本地模式下，在U盘里的视频对应的文件编号。文件以<br/>        编号.mp4命名。如001.mp4,002.mp4</li>    <li>播放协议    <ul><li>常规： 播放普通的视频文件</li>    <li>实时监控： 播放局域网下监控摄像头的实时画面</li>    </ul></li>  <li>机顶盒编号: 用于指定播放本段视频的机顶盒。</li>  <li>视频长度: 播放文件时，用于指定需要播放的时长(应小于文件本身的时长)。</li>  <li>播放地址: 网络模式下，在服务器的视频路径。如完整路径为：<br/>http://192.168.1.100/HYZG/videos/001.mp4  此处应填写001.mp4</li>  ',
        hc_dt_14 : '<h3>计数器</h3><br/>  <p><li>存放数值，可以用于数值计算和判定<br/></li></p>  <p><li>秒级计时器，可以用于秒级的计时<br/></li></p>',
        hc_dt_2 : '<h3>机顶盒、打印机等</h3><br/>  <p><li>搜寻模式<ul><li>自动发现：通过内部设备发现协议，可以自动发现主板所属主题的网络设备</li><br/>  <li>指定IP端口：配置网络设备的IP和端口</li>  </li></p>',
        hc_dt_3 : '<h3>主控板的单个输入端口</h3><br/>  <p><li>工作模式<ul><li>普通：端口有有效电平时触发</li><br/>  <li>按键按下：按键按下时，触发一次</li><br/>  <li>按键释放：按键释放时，触发一次</li><br/>  <li>触发计数：端口被触发指定次数时，触发一次</li><br/>  <li>按下持续时间：端口被持续触发指定的时长后，触发一次</li><br/>  <li>松开持续时间：端口持续未被触发指定的时长后，触发一次</li><br/>  <li>反向信号：端口没有有效电平时触发，一般用于检测输出电磁锁信号的机关</li><br/>  <li>流程复位：按键按下时，流程复位</li><br/>  </li></p>',
        hc_dt_4 : '<h3>主控板的单个输出端口</h3><br/>  <p><li>工作模式<ul><li>普通：开 继电器导通，关 继电器断开</li><br/>  <li>循环：启动后，继电器工作指定的次数。每个循环中，导通和断开时间通过<br/>“开启时长”和“关闭时长”配置，次数由“计数”配置<br/>  执行完成后，结束的状态可以是开(继电器导通)或关(继电器断开)，由“结束状态”配置</li><br/>  <li>预设亮度：仅V5硬件有效，开 按照预设值输出PWM，关 彻底断开</li><br/>  <li>渐亮渐灭：仅V5硬件有效，开 从0开始逐步增加至预设值，变化时长由“开启时长”控制<br/>关 从预设值逐步减小至彻底断开。变化时长由“关闭时长”控制</li><br/>  <li>随机闪烁：仅V5硬件PWM板有效，开 随机亮度变化，变化快慢由“开启时长”控制，熄灭时长由“关闭时长”控制<br/>关 立即熄灭</li><br/>  <li>呼吸效果：仅V5硬件PWM板有效，开 均匀亮度变化，变化快慢由“开启时长”控制<br/>关 立即熄灭</li><br/>  <li>状态跟随：开 跟随输入端口的状态，输入端口号由“计数”指定<br/>关 停止跟随状态</li><br/>  </li></p>',
        hc_dt_5 : '<h3>各种类型的门</h3><br/>  <p><li>工作模式<ul><li>电磁锁(常开)：电磁锁接在常开端，由“开门端口”控制。关门状态 端口继电器导通</li><br/>  <li>闭门器：由“开门端口”控制。关门状态 端口继电器导通</li><br/>  <li>推杆电机：由“开门端口”和“关门端口”控制。    <br/>关门状态 关门端口继电器导通“关延时”秒(如果延时为0，一直保持导通)    <br/>开门状态 开门端口继电器导通“开延时”秒(如果延时为0，一直保持导通)</li><br/>  <li>电磁锁(常闭)：电磁锁接在常闭端，由“开门端口”控制。关门状态 端口继电器断开</li><br/>  <li>闭门器带电磁锁：闭门器由“开门端口”控制。关门状态 端口继电器断开<br/>  电磁锁 由“关门端口”控制。关门状态 端口继电器导通</li><br/>  </li></p>',
        hc_dt_7 : '<h3>灯设备</h3><br/>  <p><li>端口号<ul><li>灯的供电由“端口”控制。灯点亮时，对应端口的继电器导通</li><br/>  </li></p>',
        hc_dt_8 : '<h3>音效</h3><br/>  <span>音效支持本地模式(U盘或TF卡)和网络模式(通过音效机顶盒)</span>  <p><li>文件编号<ul><li>音效对应的文件编号，文件在U盘或服务器上以编号.mp3命名。<br/>  如001.mp3,002.mp3</li><br/>  </li></p>  <p><li>机顶盒编号<ul><li>用于指定播放本音效的机顶盒。</li><br/>  </li></p>',
        mn_dt_1_p10 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        mn_dt_1_p8 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        dh_ip_w10_count_b0_0 : '绑定的计数器',
        dh_ip_w11_count_b0_0 : '绑定的计数器',
        dh_ip_w2_count_b0_0 : '绑定的计数器',
        dh_ip_w3_count_b0_0 : '按下多少次之后触发',
        dh_ip_w4_count_b0_0 : '按下多少次之后触发',
        dn_ip_w0_device_io_b0_0 : '端口号',
        dn_ip_w1_device_io_b0_0 : '端口号',
        dn_ip_w10_count_b0_0 : '计数器',
        dn_ip_w10_device_io_b0_0 : '端口号',
        dn_ip_w11_count_b0_0 : '计数器',
        dn_ip_w11_device_io_b0_0 : '端口号',
        dn_ip_w2_count_b0_0 : '计数器',
        dn_ip_w2_device_io_b0_0 : '端口号',
        dn_ip_w3_count_b0_0 : '按下次数',
        dn_ip_w3_device_io_b0_0 : '端口号',
        dn_ip_w4_count_b0_0 : '按下次数',
        dn_ip_w4_device_io_b0_0 : '端口号',
        dn_ip_w4_interval_b0_0 : '限时(秒)',
        dn_ip_w5_device_io_b0_0 : '端口号',
        dn_ip_w5_interval_b0_0 : '限时(秒)',
        dn_ip_w6_device_io_b0_0 : '端口号',
        dn_ip_w6_interval_b0_0 : '限时(秒)',
        dn_ip_w7_device_io_b0_0 : '端口号',
        dn_ip_w7_interval_b0_0 : '限时(秒)',
        dn_ip_w8_device_io_b0_0 : '端口号',
        dn_ip_w9_device_io_b0_0 : '端口号',
        wm_ip_w0 : '普通',
        wm_ip_w1 : '按键按下',
        wm_ip_w10 : '多卡识别',
        wm_ip_w11 : '遥控接收',
        wm_ip_w2 : '按键释放',
        wm_ip_w3 : '触发计数',
        wm_ip_w4 : '触发计数（限时）',
        wm_ip_w5 : '按下持续时间',
        wm_ip_w6 : '松开持续时间',
        wm_ip_w7 : '间断按下持续时间',
        wm_ip_w8 : '反向信号',
        wm_ip_w9 : '流程复位',
        at_iog_w10_result_io_b12_12 : '是',
        at_iog_w2_ck_io_b0_2 : '单次输出',
        at_iog_w2_ck_io_b3_3 : '开启',
        at_iog_w2_result_io_b0_0 : '亮起后保持',
        dh_iog_w0_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w0_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w1_fail_wait_b0_0 : '如果失败，重启等待的时间（冷却时间）',
        dh_iog_w1_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w1_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w1_start_io_b0_2 : '0 普通, 1 单按键，2 反向信号',
        dh_iog_w1_start_io_b13_13 : '去除重复按键',
        dh_iog_w1_start_io_b14_15 : '0 不开启；1 输出端口有效时，按键有效；2 输出端口无效时，按键有效',
        dh_iog_w1_start_io_b3_5 : '0 无灯, 1 按下亮，2按下亮保持，3 按下灭，4 按下灭保持，5 按下亮保持（不自动亮），6按下灭保持（不自动亮）',
        dh_iog_w1_start_io_b6_6 : '不等按完全部按键，随时进行判定，遇错输出',
        dh_iog_w1_start_io_b8_12 : '0 全部判定，1-16 只判定前1-16个按键',
        dh_iog_w10_ck_io_b0_7 : '成功数量的计数器，0 无，1～255 为计数器编号',
        dh_iog_w10_input_io_list_b0_0 : '按键的端口号',
        dh_iog_w10_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w10_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w10_output_io_list_b0_0 : '按键上灯的端口号',
        dh_iog_w10_result_io_b11_11 : '失败后输出错误信息，并停止当前这一轮',
        dh_iog_w10_result_io_b12_12 : '出错时是否扣分，0 否，1 是',
        dh_iog_w10_start_io_b0_0 : '成功数量是否累计，如果不累计，过关需要连续成功',
        dh_iog_w10_start_io_b1_5 : '过关的成功次数（最大31）',
        dh_iog_w10_start_io_b12_15 : '每次出题亮灯的数量，0 随机，1-15 数量上限',
        dh_iog_w10_start_io_b6_11 : '数值越大难度越低，最大60',
        dh_iog_w10_stop_io_b0_4 : '单次错误后闪灯，0 不闪烁，1-30闪烁次数',
        dh_iog_w11_input_io_list_b0_0 : '按键的端口号',
        dh_iog_w11_output_io_list_b0_0 : '按键上灯的端口号',
        dh_iog_w11_result_io_b8_15 : '失败重启间隔秒数',
        dh_iog_w11_start_io_b0_5 : '需要记忆的最大数量',
        dh_iog_w11_start_io_b11_15 : '谜题之间灭灯时长（0.1-3秒）',
        dh_iog_w11_start_io_b6_10 : '每个谜题亮灯时长（0.1-3秒）',
        dh_iog_w11_stop_io_b0_10 : '答题最长时间限制 1-100秒',
        dh_iog_w11_stop_io_b11_13 : '答题时按键是否跟随亮灯',
        dh_iog_w11_stop_io_b14_14 : '遇到错误立即结束本轮，并输出失败',
        dh_iog_w12_ck_io_b6_10 : '灯的最大亮度，1-100',
        dh_iog_w12_fail_wait_b0_15 : '呼吸的速度，值越大呼吸越慢',
        dh_iog_w12_output_io_list_b0_0 : '灯的端口号',
        dh_iog_w12_result_io_b11_15 : '停在最亮、最暗的时间',
        dh_iog_w13_fail_wait_b0_0 : '如果失败，重启等待的时间（冷却时间）',
        dh_iog_w13_input_io_list_b0_0 : 'IC感应器所接的输入端口（只能1个）',
        dh_iog_w13_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w13_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w13_output_io_list_b0_0 : '答案卡号列表',
        dh_iog_w13_start_io_b13_13 : '是否去除重复卡号（每一轮）',
        dh_iog_w13_start_io_b3_5 : '0 顺序模式, 1 循环模式',
        dh_iog_w13_start_io_b6_6 : '不等按完全部按键，随时进行判定，遇错输出（仅顺序模式）',
        dh_iog_w13_start_io_b8_12 : '0 全部判定，1-16 只判定前1-16个答案（仅顺序模式）',
        dh_iog_w14_ck_io_b0_5 : '编码器累计多少脉冲之后，数值变化一次',
        dh_iog_w14_input_io_list_b0_0 : '感应器所接的输入端口（只能2个）',
        dh_iog_w14_output_io_list_b0_0 : '在输出端口输出当前对应的数值',
        dh_iog_w14_result_io_b0_7 : '0 不绑定，其余数值  计数器索引号',
        dh_iog_w14_result_io_b8_15 : '当数值调整到这个值的时候，判定结果为成功',
        dh_iog_w14_start_io_b0_2 : '0 直接输出, 1 8421码',
        dh_iog_w14_start_io_b3_4 : '数值调整到头后，会自动循环到另外一端开始',
        dh_iog_w14_start_io_b5_6 : '0 正向安装，1 反向安装',
        dh_iog_w14_stop_io_b0_7 : '当数值调整到这个值的时候，判定结果为成功',
        dh_iog_w15_input_io_list_b0_0 : '如果配置了输入端口，会从输入端口读取到数值并输出',
        dh_iog_w15_output_io_list_b0_0 : '在输出端口输出当前对应的数值',
        dh_iog_w15_result_io_b0_7 : '0 不绑定，其余数值  计数器索引号',
        dh_iog_w15_result_io_b8_15 : '当数值调整到这个值的时候，判定结果为成功',
        dh_iog_w15_start_io_b0_2 : '0 直接输出, 1 8421码, 2 连续端口段',
        dh_iog_w15_start_io_b3_5 : '输入端口读取的模式，0 单个端口有效, 1 8421码',
        dh_iog_w2_fail_wait_b0_0 : '循环的间隔时间',
        dh_iog_w2_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w2_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w2_start_io_b0_0 : '端口点亮的时长',
        dh_iog_w2_stop_io_b0_0 : '端口熄灭后亮下一个的时长',
        dh_iog_w3_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w3_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w4_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w4_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w5_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w5_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w6_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w6_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w7_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w7_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w7_start_io_b0_2 : '0 普通, 1 单按键，2 反向信号',
        dh_iog_w8_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w8_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w8_start_io_b6_8 : '0 无序，只判定数量；1 有序，错误自动重启；2 有序，错误立即输出',
        dh_iog_w9_input_io_list_b0_0 : '只填一个',
        dh_iog_w9_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w9_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w9_start_io_b0_0 : '连续敲击后的间隔时间，超过该时间后的敲击计为下一段',
        dh_iog_w9_stop_io_b0_0 : '不输出错误信号，直至最终成功为止',
        dn_iog_w0_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w0_fail_wait_b0_0 : '失败等待',
        dn_iog_w0_input_io_count_b0_0 : '输入端口数',
        dn_iog_w0_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w0_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w0_on_success_ae_b0_0 : '成功音效',
        dn_iog_w0_output_io_count_b0_0 : '输出端口数',
        dn_iog_w0_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w0_result_io_b1_5 : '结果端口（信号1）',
        dn_iog_w0_start_io_b0_0 : '启动端口',
        dn_iog_w0_stop_io_b0_0 : '停止端口',
        dn_iog_w1_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w1_fail_wait_b0_0 : '失败等待',
        dn_iog_w1_input_io_count_b0_0 : '输入端口数',
        dn_iog_w1_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w1_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w1_on_success_ae_b0_0 : '成功音效',
        dn_iog_w1_output_io_count_b0_0 : '输出端口数',
        dn_iog_w1_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w1_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w1_start_io_b0_2 : '按键模式',
        dn_iog_w1_start_io_b13_13 : '去除重复',
        dn_iog_w1_start_io_b14_15 : '输出绑定',
        dn_iog_w1_start_io_b3_5 : '按键亮灯模式',
        dn_iog_w1_start_io_b6_6 : '持续判定',
        dn_iog_w1_start_io_b8_12 : '部分判定',
        dn_iog_w1_stop_io_b0_0 : '输入端口列表',
        dn_iog_w10_ck_io_b0_7 : '成功计数',
        dn_iog_w10_fail_wait_b0_0 : '自动重启时间',
        dn_iog_w10_input_io_count_b0_0 : '输入端口数',
        dn_iog_w10_input_io_list_b0_0 : '按键端口',
        dn_iog_w10_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w10_on_success_ae_b0_0 : '成功音效',
        dn_iog_w10_output_io_count_b0_0 : '按键灯数量',
        dn_iog_w10_output_io_list_b0_0 : '按键灯端口',
        dn_iog_w10_result_io_b10_10 : '指定亮灯数量',
        dn_iog_w10_result_io_b11_11 : '错误即停止',
        dn_iog_w10_result_io_b12_12 : '出错扣分',
        dn_iog_w10_start_io_b0_0 : '成功累计',
        dn_iog_w10_start_io_b1_5 : '过关成功次数',
        dn_iog_w10_start_io_b12_15 : '每题亮灯数量',
        dn_iog_w10_start_io_b6_11 : '难度系数',
        dn_iog_w10_stop_io_b0_4 : '错误后闪灯',
        dn_iog_w10_stop_io_b11_15 : '重启间隔',
        dn_iog_w10_stop_io_b5_9 : '错误闪灯间隔',
        dn_iog_w11_input_io_count_b0_0 : '输入端口数',
        dn_iog_w11_input_io_list_b0_0 : '按键端口',
        dn_iog_w11_output_io_count_b0_0 : '按键灯数量',
        dn_iog_w11_output_io_list_b0_0 : '按键灯端口',
        dn_iog_w11_result_io_b8_15 : '重启间隔',
        dn_iog_w11_start_io_b0_5 : '谜题数量',
        dn_iog_w11_start_io_b11_15 : '灭灯时长',
        dn_iog_w11_start_io_b6_10 : '亮灯时长',
        dn_iog_w11_stop_io_b0_10 : '答题时限',
        dn_iog_w11_stop_io_b11_13 : '答题按键灯',
        dn_iog_w11_stop_io_b14_14 : '错误立即输出',
        dn_iog_w12_ck_io_b6_10 : '最大亮度',
        dn_iog_w12_fail_wait_b0_15 : '呼吸速度',
        dn_iog_w12_output_io_count_b0_0 : '按键灯数量',
        dn_iog_w12_output_io_list_b0_0 : '灯端口',
        dn_iog_w12_result_io_b11_15 : '停留时间',
        dn_iog_w13_fail_wait_b0_0 : '失败等待',
        dn_iog_w13_input_io_count_b0_0 : '输入端口数',
        dn_iog_w13_input_io_list_b0_0 : '输入端口',
        dn_iog_w13_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w13_on_success_ae_b0_0 : '成功音效',
        dn_iog_w13_output_io_count_b0_0 : '答案数',
        dn_iog_w13_output_io_list_b0_0 : '答案列表',
        dn_iog_w13_start_io_b13_13 : '去除重复',
        dn_iog_w13_start_io_b3_5 : '判定模式',
        dn_iog_w13_start_io_b6_6 : '顺序模式持续判定',
        dn_iog_w13_start_io_b8_12 : '顺序模式部分判定',
        dn_iog_w14_ck_io_b0_5 : '每档脉冲数量',
        dn_iog_w14_input_io_count_b0_0 : '输入端口数',
        dn_iog_w14_input_io_list_b0_0 : '输入端口',
        dn_iog_w14_output_io_count_b0_0 : '输出端口数',
        dn_iog_w14_output_io_list_b0_0 : '输出端口',
        dn_iog_w14_result_io_b0_7 : '绑定计数器',
        dn_iog_w14_result_io_b8_15 : '预期结果',
        dn_iog_w14_start_io_b0_2 : '结果输出模式',
        dn_iog_w14_start_io_b3_4 : '循环调节',
        dn_iog_w14_start_io_b5_6 : '感应器方向',
        dn_iog_w14_stop_io_b0_7 : '数值上限',
        dn_iog_w15_input_io_count_b0_0 : '输入端口数',
        dn_iog_w15_input_io_list_b0_0 : '输入端口',
        dn_iog_w15_output_io_count_b0_0 : '输出端口数',
        dn_iog_w15_output_io_list_b0_0 : '输出端口',
        dn_iog_w15_result_io_b0_7 : '绑定计数器',
        dn_iog_w15_result_io_b8_15 : '预期结果',
        dn_iog_w15_start_io_b0_2 : '结果输出模式',
        dn_iog_w15_start_io_b3_5 : '输入模式',
        dn_iog_w2_ck_io_b0_2 : '是否单次输出',
        dn_iog_w2_ck_io_b3_3 : '随机顺序',
        dn_iog_w2_fail_wait_b0_0 : '循环间隔',
        dn_iog_w2_input_io_count_b0_0 : '输入端口数',
        dn_iog_w2_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w2_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w2_on_success_ae_b0_0 : '成功音效',
        dn_iog_w2_output_io_count_b0_0 : '输出端口数',
        dn_iog_w2_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w2_result_io_b0_0 : '是否保持点亮',
        dn_iog_w2_start_io_b0_0 : '点亮时间',
        dn_iog_w2_stop_io_b0_0 : '熄灭时间',
        dn_iog_w3_input_io_count_b0_0 : '输入端口数',
        dn_iog_w3_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w3_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w3_on_success_ae_b0_0 : '成功音效',
        dn_iog_w3_output_io_count_b0_0 : '节拍数量',
        dn_iog_w3_output_io_list_b0_0 : '节拍列表',
        dn_iog_w3_result_io_b0_8 : '整体间隔',
        dn_iog_w3_start_io_b0_12 : '端口',
        dn_iog_w3_start_io_b14_14 : '循环播放',
        dn_iog_w3_stop_io_b0_4 : '点亮时间',
        dn_iog_w3_stop_io_b10_15 : '节拍间隔',
        dn_iog_w3_stop_io_b5_9 : '熄灭时间',
        dn_iog_w4_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w4_fail_wait_b0_0 : '失败等待',
        dn_iog_w4_input_io_count_b0_0 : '输入端口数',
        dn_iog_w4_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w4_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w4_on_success_ae_b0_0 : '成功音效',
        dn_iog_w4_output_io_count_b0_0 : '输出端口数',
        dn_iog_w4_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w4_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w4_start_io_b0_0 : '启动端口',
        dn_iog_w4_stop_io_b0_0 : '停止端口',
        dn_iog_w5_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w5_fail_wait_b0_0 : '失败等待',
        dn_iog_w5_input_io_count_b0_0 : '输入端口数',
        dn_iog_w5_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w5_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w5_on_success_ae_b0_0 : '成功音效',
        dn_iog_w5_output_io_count_b0_0 : '输出端口数',
        dn_iog_w5_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w5_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w5_start_io_b0_0 : '启动端口',
        dn_iog_w5_stop_io_b0_0 : '停止端口',
        dn_iog_w6_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w6_fail_wait_b0_0 : '失败等待',
        dn_iog_w6_input_io_count_b0_0 : '输入端口数',
        dn_iog_w6_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w6_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w6_on_success_ae_b0_0 : '成功音效',
        dn_iog_w6_output_io_count_b0_0 : '输出端口数',
        dn_iog_w6_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w6_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w6_start_io_b0_0 : '启动端口',
        dn_iog_w6_stop_io_b0_0 : '停止端口',
        dn_iog_w7_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w7_fail_wait_b0_0 : '失败等待',
        dn_iog_w7_input_io_count_b0_0 : '输入端口数',
        dn_iog_w7_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w7_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w7_on_success_ae_b0_0 : '成功音效',
        dn_iog_w7_output_io_count_b0_0 : '结果数量',
        dn_iog_w7_output_io_list_b0_0 : '结果列表',
        dn_iog_w7_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w7_start_io_b0_2 : '按键模式',
        dn_iog_w7_stop_io_b0_0 : '停止端口',
        dn_iog_w8_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w8_fail_wait_b0_0 : '失败等待',
        dn_iog_w8_input_io_count_b0_0 : '输入端口数',
        dn_iog_w8_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w8_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w8_on_success_ae_b0_0 : '成功音效',
        dn_iog_w8_output_io_count_b0_0 : '结果数量',
        dn_iog_w8_output_io_list_b0_0 : '结果列表',
        dn_iog_w8_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w8_start_io_b6_8 : '判定模式',
        dn_iog_w8_stop_io_b0_0 : '停止端口',
        dn_iog_w9_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w9_fail_wait_b0_0 : '自动重启时间',
        dn_iog_w9_input_io_count_b0_0 : '输入端口数',
        dn_iog_w9_input_io_list_b0_0 : '输入端口',
        dn_iog_w9_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w9_on_success_ae_b0_0 : '成功音效',
        dn_iog_w9_output_io_count_b0_0 : '节奏组数量',
        dn_iog_w9_output_io_list_b0_0 : '节奏组列表',
        dn_iog_w9_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w9_start_io_b0_0 : '节奏段间隔',
        dn_iog_w9_stop_io_b0_0 : '持续判定',
        ec_iog_w1_input_io_list : '端口编辑',
        ec_iog_w1_output_io_list : '端口编辑',
        ec_iog_w1_stop_io : '端口编辑',
        ec_iog_w10_input_io_list : '按键端口编辑',
        ec_iog_w10_output_io_list : '灯端口编辑',
        ec_iog_w11_input_io_list : '按键端口编辑',
        ec_iog_w11_output_io_list : '灯端口编辑',
        ec_iog_w12_output_io_list : '灯端口编辑',
        ec_iog_w13_input_io_list : '端口编辑',
        ec_iog_w13_output_io_list : '端口编辑',
        ec_iog_w14_input_io_list : '端口编辑',
        ec_iog_w14_output_io_list : '端口编辑',
        ec_iog_w15_input_io_list : '端口编辑',
        ec_iog_w15_output_io_list : '端口编辑',
        ec_iog_w2_output_io_list : '端口编辑',
        ec_iog_w5_input_io_list : '端口编辑',
        ec_iog_w6_input_io_list : '端口编辑',
        ec_iog_w7_input_io_list : '端口编辑',
        ec_iog_w7_output_io_list : '端口编辑',
        ec_iog_w8_input_io_list : '端口编辑',
        ec_iog_w8_output_io_list : '结果编辑',
        ec_iog_w9_input_io_list : '端口编辑',
        ec_iog_w9_output_io_list : '结果编辑',
        ec_dt_1_p8 : '端口编辑',
        ei_dt_1_p8 : '端口',
        ev_dt_1_p8 : '端口号',
        ec_dt_1_p10 : '端口编辑',
        ei_dt_1_p10 : '端口',
        ev_dt_1_p10 : '端口号',
        ei_iog_w1_input_io_list : '端口',
        ei_iog_w1_output_io_list : '端口',
        ei_iog_w1_stop_io : '端口',
        ei_iog_w10_input_io_list : '端口',
        ei_iog_w10_output_io_list : '端口',
        ei_iog_w11_input_io_list : '端口',
        ei_iog_w11_output_io_list : '端口',
        ei_iog_w12_output_io_list : '端口',
        ei_iog_w13_input_io_list : '端口',
        ei_iog_w13_output_io_list : '答案',
        ei_iog_w14_input_io_list : '端口',
        ei_iog_w14_output_io_list : '端口',
        ei_iog_w15_input_io_list : '端口',
        ei_iog_w15_output_io_list : '端口',
        ei_iog_w2_output_io_list : '端口',
        ei_iog_w5_input_io_list : '端口',
        ei_iog_w6_input_io_list : '端口',
        ei_iog_w7_input_io_list : '端口',
        ei_iog_w7_output_io_list : '端口',
        ei_iog_w8_input_io_list : '端口',
        ei_iog_w8_output_io_list : '计数',
        ei_iog_w9_input_io_list : '端口',
        ei_iog_w9_output_io_list : '敲击次数',
        ev_iog_w1_input_io_list : '端口号',
        ev_iog_w1_output_io_list : '端口号',
        ev_iog_w1_stop_io : '端口号',
        ev_iog_w10_input_io_list : '端口号',
        ev_iog_w10_output_io_list : '端口号',
        ev_iog_w11_input_io_list : '端口号',
        ev_iog_w11_output_io_list : '端口号',
        ev_iog_w12_output_io_list : '端口号',
        ev_iog_w13_input_io_list : '端口号',
        ev_iog_w13_output_io_list : '答案卡号',
        ev_iog_w14_input_io_list : '端口号',
        ev_iog_w14_output_io_list : '端口号',
        ev_iog_w15_input_io_list : '端口号',
        ev_iog_w15_output_io_list : '端口号',
        ev_iog_w2_output_io_list : '端口号',
        ev_iog_w5_input_io_list : '端口号',
        ev_iog_w6_input_io_list : '端口号',
        ev_iog_w7_input_io_list : '端口号',
        ev_iog_w7_output_io_list : '端口号',
        ev_iog_w8_input_io_list : '端口号',
        ev_iog_w8_output_io_list : '按下次数',
        ev_iog_w9_input_io_list : '端口号',
        ev_iog_w9_output_io_list : '节奏次数',
        it_iog_w10_result_io_b12_12 : '否',
        it_iog_w2_ck_io_b0_2 : '循环输出',
        it_iog_w2_ck_io_b3_3 : '不开启',
        it_iog_w2_result_io_b0_0 : '熄灭亮下一个',
        wm_iog_w0 : '外接模块',
        wm_iog_w1 : '顺序端口组',
        wm_iog_w10 : '地鼠游戏',
        wm_iog_w11 : '记忆按键',
        wm_iog_w12 : '呼吸灯组',
        wm_iog_w13 : '多卡顺序识别',
        wm_iog_w14 : '旋转编码器',
        wm_iog_w15 : '数字输入输出',
        wm_iog_w2 : '顺序输出',
        wm_iog_w3 : '节拍输出',
        wm_iog_w4 : '输入并联',
        wm_iog_w5 : '输入串联',
        wm_iog_w6 : '无序按键',
        wm_iog_w7 : '循环按键',
        wm_iog_w8 : '循环按键',
        wm_iog_w9 : '节奏判定',
        at_op_w1_finish_status_b0_0 : '开启',
        at_op_w1_ms_ctrl_b0_0 : '毫秒',
        at_op_w2_finish_status_b0_0 : '开启',
        at_op_w4_finish_status_b0_0 : '开启',
        at_op_w6_finish_status_b0_0 : '开启',
        dh_op_w1_count_b0_0 : '达到此次数之后停止循环，并且端口保持XX状态',
        dh_op_w1_ms_ctrl_b0_0 : '控制精度的单位',
        dh_op_w2_count_b0_0 : '达到此次数之后停止循环，并且端口保持XX状态',
        dh_op_w3_brightness_b0_0 : '端口打开之后的亮度值',
        dh_op_w4_brightness_b0_0 : '最亮时候的亮度值',
        dh_op_w4_brightness_low_b0_0 : '最暗时候的亮度值',
        dh_op_w4_interval1_b0_0 : '变亮的时长，值越大变化越慢',
        dh_op_w4_interval2_b0_0 : '变暗的时长，值越大变化越慢',
        dh_op_w5_brightness_b0_0 : '最亮时候的亮度值',
        dh_op_w5_brightness_low_b0_0 : '最暗时候的亮度值',
        dh_op_w5_count_b0_0 : '闪烁时亮起的占比，数值越大，亮的时间越长',
        dh_op_w5_interval1_b0_0 : '亮度变化速度，值越大越慢',
        dh_op_w5_interval2_b0_0 : '熄灭保持的时间，值越大越长',
        dh_op_w6_brightness_b0_0 : '最亮时候的亮度值',
        dh_op_w6_brightness_low_b0_0 : '最暗时候的亮度值',
        dh_op_w6_interval1_b0_0 : '亮度变化速度，值越大越慢',
        dh_op_w6_interval2_b0_0 : '在最亮、最暗保持的时间，值越大越长',
        dh_op_w8_count_b0_0 : '跟随的输入端口号（1-200）',
        dn_op_w0_device_io_b0_0 : '端口号',
        dn_op_w1_count_b0_0 : '循环次数',
        dn_op_w1_device_io_b0_0 : '端口号',
        dn_op_w1_finish_status_b0_0 : '结束状态',
        dn_op_w1_interval1_b0_0 : '开启时长',
        dn_op_w1_interval2_b0_0 : '关闭时长',
        dn_op_w1_ms_ctrl_b0_0 : '毫秒级控制',
        dn_op_w2_count_b0_0 : '循环次数',
        dn_op_w2_device_io_b0_0 : '端口号',
        dn_op_w2_finish_status_b0_0 : '结束状态',
        dn_op_w2_interval1_b0_0 : '开启时长',
        dn_op_w2_interval2_b0_0 : '关闭时长',
        dn_op_w3_brightness_b0_0 : '亮度',
        dn_op_w3_device_io_b0_0 : '端口号',
        dn_op_w4_brightness_b0_0 : '最大亮度',
        dn_op_w4_brightness_low_b0_0 : '最小亮度',
        dn_op_w4_device_io_b0_0 : '端口号',
        dn_op_w4_finish_status_b0_0 : '结束状态',
        dn_op_w4_interval1_b0_0 : '变亮时长',
        dn_op_w4_interval2_b0_0 : '变暗时长',
        dn_op_w5_brightness_b0_0 : '最大亮度',
        dn_op_w5_brightness_low_b0_0 : '最小亮度',
        dn_op_w5_count_b0_0 : '闪烁间隔',
        dn_op_w5_device_io_b0_0 : '端口号',
        dn_op_w5_interval1_b0_0 : '变化速度',
        dn_op_w5_interval2_b0_0 : '熄灭时长',
        dn_op_w6_brightness_b0_0 : '最大亮度',
        dn_op_w6_brightness_low_b0_0 : '最小亮度',
        dn_op_w6_device_io_b0_0 : '端口号',
        dn_op_w6_finish_status_b0_0 : '结束状态',
        dn_op_w6_interval1_b0_0 : '变化速度',
        dn_op_w6_interval2_b0_0 : '保持时间',
        dn_op_w7_device_io_b0_0 : '端口号',
        dn_op_w8_count_b0_0 : '跟随输入端口',
        dn_op_w8_device_io_b0_0 : '端口号',
        it_op_w1_finish_status_b0_0 : '关闭',
        it_op_w1_ms_ctrl_b0_0 : '秒',
        it_op_w2_finish_status_b0_0 : '关闭',
        it_op_w4_finish_status_b0_0 : '关闭',
        it_op_w6_finish_status_b0_0 : '关闭',
        wm_op_w0 : '普通',
        wm_op_w1 : '循环',
        wm_op_w2 : '随机循环',
        wm_op_w3 : '预设亮度',
        wm_op_w4 : '渐亮渐灭',
        wm_op_w5 : '随机闪烁',
        wm_op_w6 : '呼吸效果',
        wm_op_w7 : '保留',
        wm_op_w8 : '状态跟随',
        dh_dt_1_p2 : '',
        dh_dt_1_p3 : '未用可不填',
        dh_dt_1_p4 : '未用可不填',
        dh_dt_1_p5 : '外部模块时，信号1所接的主控板端口',
        dn_dt_1_p4 : '停止端口',
        dn_dt_1_p5 : '结果端口(信号1)',
        dn_dt_1_p6 : '触发端口(信号2)',
        dn_dt_1_p7 : '失败等待',
        dn_dt_1_p8 : '输入端口列表',
        dn_dt_1_p9 : '输入端口数',
        dn_dt_1_p10 : '输出端口列表',
        dn_dt_1_p11 : '输出端口数',
        dn_dt_1_p12 : '失败音效',
        dn_dt_1_p13 : '成功音效',
        dn_dt_8_p3 : '播放音量',

        p4_lgn_tt_country_code : '区号',
        p9_zbxx_col_id : 'ID',
        p9_zbxx_lbl_lang_yue : '粤语(chs)',
        p9_zbxx_lbl_runtime_info : '运行信息',
        p9_zbxx_lbl_normal_running : '正常运行',
        p9_zbxx_lbl_emergency : '应急模式',
        p9_zbxx_btn_switch : '切换',
        p9_zbxx_lbl_current_theme : '当前：',
        p9_zbxx_lbl_switch_theme : '切换主题：',
        p9_zbxx_lbl_boot_theme_default : '启动默认：',
        p9_zbxx_tab_info_short : '信息',
        p9_zbxx_tab_setting_short : '设置',
        p9_zbxx_tab_port_short : '端口',
        p9_zbxx_lbl_elapsed : '用时',
        p9_zbxx_msg_sel_correct_theme_1_5 : '请选择正确的主题（1-5）',
        p9_zbxx_msg_theme_switching_short : '正在切换主题...',
        p9_zbxx_msg_please_sel_boot_theme : '请选择启动主题',
        p9_zbxx_msg_sel_correct_theme_0_5 : '请选择正确的主题（0-5）',
        p9_zbxx_lbl_theme_short : '主题',
        p9_zbxx_lbl_progress : '进度：',
        p9_zbxx_lbl_scene_time : '场景用时：',
        p9_zbxx_lbl_current_scene : '当前场景',
        p9_zbxx_lbl_not_started : '未启动',
        p9_zbxx_lbl_select_subdev_type : '选择设备类型',
        p9_zbxx_lbl_device_offline : '设备离线',
        p9_zbxx_lbl_show_limit_empty : '场次余额已用完',
        p9_zbxx_lbl_show_limit_low : '场次余额所剩不多',
        p9_zbxx_lbl_no_data : '无数据',
        p9_zbxx_cfm_upgrade_theme : '确定升级主题？',
        p9_zbxx_lbl_same_port_mutex : '同端口互斥',
        p9_zbxx_lbl_net_reconnect_try : '网络重连尝试',
        p9_zbxx_lbl_audio_control_option : '音频控制选项',
        p9_zbxx_lbl_input_port_module : '输入端口模块',
        p9_zbxx_lbl_output_port_module : '输出端口模块',
        p9_zbxx_lbl_port_status : '端口状态',
        p9_zbxx_lbl_board_offline : '主板不在线',
        p6_te_scn_lbl_math_add : '加上',
        p6_te_scn_lbl_math_sub : '减去',
        p6_te_scn_lbl_math_mul : '乘以',
        p6_te_scn_lbl_math_div : '除以',
        p6_te_scn_msg_scene_lst : '场景列表',
        p9_yxjl_lbl_board : '主控',
        p9_yxjl_ph_select_board : '请选择主控',
        p9_yxjl_col_boot_count : '运行计数',
        p9_yxjl_col_date : '日期',
        p9_yxjl_col_detail : '详细',
        p9_yxjl_btn_export_exec_record : '导出执行记录',
        p9_yxjl_col_log : '日志',
        p9_yxjl_btn_view : '查看',
        p9_yxjl_btn_download : '下载',
        p9_yxjl_col_scene : '场景',
        p9_yxjl_col_scene_name : '场景名称',
        p9_yxjl_col_enter_time : '开始时间',
        p9_yxjl_col_leave_time : '结束时间',
        p9_yxjl_col_duration : '持续时间',
        p9_yxjl_tab_main_task : '主任务',
        p9_yxjl_lbl_run_log : '运行日志',
        p9_yxjl_empty_no_board : '没有主控板',
        p9_yxjl_unit_hour : '小时',
        p9_yxjl_unit_minute : '分',
        p9_yxjl_unit_second : '秒',
        p9_yxjl_msg_download_failed : '下载失败',
        p9_yxjl_msg_log_url_missing : '无法获取日志文件地址',
        p9_yxjl_sheet_run_record : '运行记录',
        p9_yxjl_file_exec_record : '执行记录',
        p9_yxjl_file_default : '运行记录',
        p9_yxjl_msg_export_success : '运行记录已导出为 ',
        p9_yxjl_msg_export_failed : '导出运行记录失败: ',
        p9_yxjl_xlsx_col_time : '时间',
        p9_yxjl_xlsx_col_tick : '时间戳',
        p9_yxjl_xlsx_col_device_category : '设备类别',
        p9_yxjl_xlsx_col_device_index : '设备索引',
        p9_yxjl_xlsx_col_operation_code : '操作代码',
        p9_yxjl_xlsx_col_parameter : '参数',
        p9_yxjl_xlsx_col_operation : '操作',

        // --- action_name i18n keys (an_) ---
        'an_0_1': '启动',
        'an_0_0': '停止',
        'an_1_1': '启动',
        'an_1_0': '停止',
        'an_2_1': '启动',
        'an_2_0': '停止',
        'an_3_1': '启动',
        'an_3_0': '停止',
        'an_4_1': '启动',
        'an_4_0': '停止',
        'an_4_2': '设置亮度',
        'an_4_11': '状态反转',
        'an_5_0': '开/解锁',
        'an_5_1': '关/闭合',
        'an_5_2': '反转',
        'an_7_1': '打开',
        'an_7_0': '关闭',
        'an_7_2': '设置亮度',
        'an_8_1': '播放',
        'an_8_0': '停止',
        'an_8_4': '设置音量',
        'an_9_0': '停止',
        'an_9_1': '播放',
        'an_10_1': '播放',
        'an_10_0': '停止',
        'an_10_2': '恢复',
        'an_10_3': '暂停',
        'an_10_4': '设置音量',
        'an_10_5': '优先级播放',
        'an_11_1': '播放',
        'an_11_0': '停止',
        'an_11_2': '恢复',
        'an_11_3': '暂停',
        'an_11_5': '循环模式',
        'an_12_1': '播放',
        'an_12_2': '恢复',
        'an_12_3': '暂停',
        'an_13_1': '启动',
        'an_13_0': '停止',
        'an_13_2': '恢复',
        'an_13_3': '暂停',
        'an_14_0': '停止',
        'an_14_1': '启动',
        'an_14_2': '赋值',
        'an_14_4': '加',
        'an_14_5': '减',
        'an_14_6': '乘',
        'an_14_7': '除',
        'an_14_10': '产生随机值',
        'an_14_12': '加上',
        'an_14_13': '减去',
        'an_14_14': '乘以',
        'an_14_15': '除以',
        'an_30_1': '启动',
        'an_30_0': '停止',
        'an_30_8': '重设计时',
        'an_30_9': '流程复位',
        'an_30_3': '流程跳关',
        'an_31_1': '始终执行',
        'an_33_1': '网络就绪',
        'an_32_1': '跳关',
        'an_34_1': '收房间完成',
        'an_35_1': '主题开始',
        'an_36_1': '主题结束',
        'an_39_1': '场景效果触发',
        'an_40_1': '语言设置',

        // --- logic_name i18n keys (ln_) ---
        'ln_1_true': '成功',
        'ln_1_false': '失败',
        'ln_2_true': '成功',
        'ln_2_false': '失败',
        'ln_3_true': '有效',
        'ln_3_false': '无效',
        'ln_3_2': '等于',
        'ln_3_3': '大于',
        'ln_3_4': '大于等于',
        'ln_3_5': '小于',
        'ln_3_6': '小于等于',
        'ln_3_7': '不等于',
        'ln_4_true': '有效',
        'ln_4_false': '无效',
        'ln_5_true': '关闭',
        'ln_5_false': '打开',
        'ln_6_true': '打开',
        'ln_6_false': '关闭',
        'ln_7_true': '打开',
        'ln_7_false': '关闭',
        'ln_8_true': '打开',
        'ln_8_false': '关闭',
        'ln_9_true': '打开',
        'ln_9_false': '关闭',
        'ln_10_true': '打开',
        'ln_10_false': '关闭',
        'ln_11_true': '打开',
        'ln_11_false': '关闭',
        'ln_12_true': '打开',
        'ln_12_false': '关闭',
        'ln_13_true': '成功',
        'ln_13_false': '失败',
        'ln_13_2': '收到事件',
        'ln_14_2': '等于',
        'ln_14_3': '大于',
        'ln_14_4': '大于等于',
        'ln_14_5': '小于',
        'ln_14_6': '小于等于',
        'ln_14_7': '不等于',
        'ln_14_8': '变成',
        'ln_31_true' : '成立',
        'ln_33_true' : '就绪',
        'an_37_1' : '流程复位',
        'an_37_2' : '流程暂停',
        'an_37_3' : '流程加速',
        'an_37_4' : '流程减速',

        tn_task_1 : '主任务',
        tn_task_2 : '任务2',
        tn_task_3 : '任务3',
        tn_task_4 : '任务4',
        tn_task_5 : '任务5',
        tn_task_6 : '任务6',
        tn_task_7 : '任务7',
        tn_task_8 : '任务8',
        tn_task_9 : '任务9',
        tn_task_10 : '任务10',
        tn_task_11 : '任务11',
        tn_task_12 : '任务12',
        tn_task_13 : '任务13',
        tn_task_14 : '任务14',
        tn_task_15 : '任务15',
        tn_task_16 : '任务16',
        tn_task_17 : '任务17',
        tn_task_18 : '任务18',
        tn_task_19 : '任务19',
        tn_task_20 : '任务20',
        tn_task_21 : '任务21',
        tn_task_22 : '任务22',
        tn_task_23 : '任务23',
        tn_task_24 : '任务24',
        tn_task_25 : '任务25',
        tn_task_26 : '任务26',
        tn_task_27 : '任务27',
        tn_task_28 : '任务28',
        tn_task_29 : '任务29',
        tn_task_30 : '任务30',
        tn_task_31 : '任务31',
        tn_task_32 : '任务32',
        tn_task_33 : '任务33',
        tn_task_34 : '任务34',
        tn_task_35 : '任务35',
        tn_task_36 : '任务36',
        tn_task_37 : '任务37',
        tn_task_38 : '任务38',
        tn_task_39 : '任务39',
        tn_task_40 : '任务40',
        tn_task_41 : '任务41',
        tn_task_42 : '任务42',
        tn_task_43 : '任务43',
        tn_task_44 : '任务44',
        tn_task_45 : '任务45',
        tn_task_46 : '任务46',
        tn_task_47 : '任务47',
        tn_task_48 : '任务48',
        tn_task_49 : '任务49',
        tn_task_50 : '任务50',
        tn_task_51 : '任务51',
        tn_task_52 : '任务52',
        tn_task_53 : '任务53',
        tn_task_54 : '任务54',
        tn_task_55 : '任务55',
        tn_task_56 : '任务56',
        tn_task_57 : '任务57',
        tn_task_58 : '任务58',
        tn_task_59 : '任务59',
        tn_task_60 : '任务60',
        tn_task_61 : '任务61',
        tn_task_62 : '任务62',
        tn_task_63 : '任务63',
        tn_task_64 : '任务64',
        tn_task_65 : '任务65',
        tn_task_66 : '任务66',
        tn_task_67 : '任务67',
        tn_task_68 : '任务68',
        tn_task_69 : '任务69',
        tn_task_70 : '任务70',
        tn_task_71 : '任务71',
        tn_task_72 : '任务72',
        tn_task_73 : '任务73',
        tn_task_74 : '任务74',
        tn_task_75 : '任务75',
        tn_task_76 : '任务76',
        tn_task_77 : '任务77',
        tn_task_78 : '任务78',
        tn_task_79 : '任务79',
        tn_task_80 : '任务80',
        tn_task_81 : '任务81',
        tn_task_82 : '任务82',
        tn_task_83 : '任务83',
        tn_task_84 : '任务84',
        tn_task_85 : '任务85',
        tn_task_86 : '任务86',
        tn_task_87 : '任务87',
        tn_task_88 : '任务88',
        tn_task_89 : '任务89',
        tn_task_90 : '任务90',
        tn_task_91 : '任务91',
        tn_task_92 : '任务92',
        tn_task_93 : '任务93',
        tn_task_94 : '任务94',
        tn_task_95 : '任务95',
        tn_task_96 : '任务96',
        tn_task_97 : '任务97',
        tn_task_98 : '任务98',
        tn_task_99 : '任务99',
        tn_task_100 : '任务100',
        tn_task_101 : '任务101',
        tn_task_102 : '任务102',
        tn_task_103 : '任务103',
        tn_task_104 : '任务104',
        tn_task_105 : '任务105',
        tn_task_106 : '任务106',
        tn_task_107 : '任务107',
        tn_task_108 : '任务108',
        tn_task_109 : '任务109',
        tn_task_110 : '任务110',
        tn_task_111 : '任务111',
        tn_task_112 : '任务112',
        tn_task_113 : '任务113',
        tn_task_114 : '任务114',
        tn_task_115 : '任务115',
        tn_task_116 : '任务116',
        tn_task_117 : '任务117',
        tn_task_118 : '任务118',
        tn_task_119 : '任务119',
        tn_task_120 : '任务120',
        tn_task_121 : '任务121',
        tn_task_122 : '任务122',
        tn_task_123 : '任务123',
        tn_task_124 : '任务124',
        tn_task_125 : '任务125',
        tn_task_126 : '任务126',
        tn_task_127 : '任务127',
        tn_task_128 : '任务128',



    },
    organization,
    themeSceneExport,
    role: {
        permission: '权限',
    },
    user: {

    },
    title: {

    },

































































































































}
